import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Switch,
  TextField,
  Tooltip,
  Typography,
} from '@material-ui/core';
import { DialogContentText } from '@material-ui/core/';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import InfoIcon from '@material-ui/icons/Info';
import { cloneDeep, debounce, isEmpty, set } from 'lodash-es';
import moment from 'moment-timezone';
import React from 'react';
import update from 'react-addons-update'; // ES6
import { v4 as uuid } from 'uuid';

import {
  cleanCommaSeparatedString,
  ReportingEventTypes,
  track,
} from '~/src/dash/analytics/analytics';
import { getBidderGroups, IBidderGroup } from '~/src/dash/api/bidder-group';
import { IAdserverCampaign } from '~/src/dash/api/campaign/campaign';
import { getChannelGroupsPromise } from '~/src/dash/api/channel-group';
import { getSitesPromise } from '~/src/dash/api/channels';
import {
  createReport,
  defaultReportFilterConfig,
  getAudienceSegments,
  getBidderLabels,
  getCampaigns,
  getChannelLabels,
  getFWPublisherIDs,
  getPublisherAdQualityStatus,
  getReseller,
  getUniqueLineItemAliases,
  IAdserverAlias,
  IAudienceSegment,
  IBidderLabel,
  IChannelGroup,
  IChannelLabel,
  ICountryGroup,
  IHeaderBidder,
  IReport,
  IReportFilterConfig,
  IReseller,
  ISite,
  queryHeaderBidders,
  ReportActive,
  ReportInactive,
  ReportType,
  REPORTTYPE_ADVERTISER_RULES,
  REPORTTYPE_BID_FLOOR_SETTINGS_REPORT,
  REPORTTYPE_BID_SAVER_TRUE_LIFT,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_CREATIVE_REVIEW,
  REPORTTYPE_CREATIVE_VALIDATION,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS_SUPER,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_ENRICHMENT,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_SCAN_ALL,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_IAS_DEVICE,
  REPORTTYPE_IAS_FIRST_PARTY,
  REPORTTYPE_IAS_PERFORMANCE,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_IAS_YOUTUBE,
  REPORTTYPE_POD_HOURLY,
  REPORTTYPE_SHARE_OF_VOICE,
  REPORTTYPE_STREAM,
  REPORTTYPE_STREAM_USER_ACTIVITY,
  REPORTTYPE_TTD,
  scheduleReport,
  sendEmail,
  SiteActiveActive,
  SuperOnlyActive,
  SuperOnlyInactive,
  updateReport,
} from '~/src/dash/api/console-api';
import { getCountryGroupsByPublisherID } from '~/src/dash/api/country-group';
import {
  ECurrencyType,
  genCurrencyList,
  getExchangeRate,
  IExchangeRate,
} from '~/src/dash/api/exchange-rates';
import {
  IIASFirstAndThirdPartyRequestBody,
  isIASReport,
  sendIASEmail,
} from '~/src/dash/api/ias-wrapper-api/ias-wrapper-api';
import {
  generateDestinationMenuList,
  generateInventoryRouteMenuList,
  getInventoryRoutesByPublisherID,
  IDestination,
} from '~/src/dash/api/inventory_routes';
import { getNetworks, INetwork, transformNetworkWrapper } from '~/src/dash/api/network';
import { getAdserverOrders, getUniqueOrderAliases, IAdserverOrder } from '~/src/dash/api/order';
import {
  ReportRetrieveMethod,
  ReportRetrieveMethodDownload,
  ReportRetrieveMethodEmail,
  ReportRetrieveMethodPreview,
  ReportRetrieveMethodSchedule,
  ReportRetrieveMethodUnknown,
} from '~/src/dash/api/report';
import { IObject } from '~/src/dash/api/resource-transforms';
import { IHttpResponse } from '~/src/dash/api/rest';
import { getS3AccessPoint, IS3AccessPoint } from '~/src/dash/api/s3-access-points';
import { EBool } from '~/src/dash/api/types/bool';
import {
  DateTimeRangeComponent,
  IDateRangeChangeEvent,
} from '~/src/dash/components/datepicker/date-time-range-component';
import {
  CategoryMultiSelect,
  IMultiSelectOption,
} from '~/src/dash/components/dropdowns/category-multiselect';
import { MaterialLabelDropdownMulti } from '~/src/dash/components/material-label-dropdown-multi';
import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { SortByMode } from '~/src/dash/components/material-search-dropdown-multi-list';
import { ISelectModel } from '~/src/dash/components/model';
import { ModelPrimaryButton } from '~/src/dash/components/model-primary-button';
import { ModelSecondaryButton } from '~/src/dash/components/model-secondary-button';
import { ModelTopBar } from '~/src/dash/components/model-topbar';
import { genQuickFilter } from '~/src/dash/components/quick-filter-dropdown';
import { genTimezoneList } from '~/src/dash/globals/timezone';
import { Col, Cols, Panel, PanelBreak, Panels, Rows, spacing } from '~/src/dash/publicaUI';
import { IStore } from '~/src/dash/reducers/store';
import { getResellerID, getResellerTitle } from '~/src/dash/resellers/utils/importResellerConfig';
import { getColorTheme } from '~/src/dash/resellers/utils/importResellerConfig';
import {
  createDownloadReportURL,
  extractRouteParams,
  genReportURL,
  navigate,
  RouteBidderReportsExisting,
  RouteBidderReportsList,
} from '~/src/dash/router/routes';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import {
  IBaseState,
  IHistoryProps,
  IReduxActionProps,
  ISessionStateProps,
  IUserStateProps,
  IWithStylesProps,
} from '~/src/dash/types/props';
import { ChipInactive } from '~/src/dash/utils/campaign-status';
import { publicaColors } from '~/src/dash/utils/colors';
import {
  generateCountriesMenuList,
  generateCountryGroupMenuList,
  generateStatesMenuList,
  selectCountries,
} from '~/src/dash/utils/countries';
import {
  formatDateEndDay,
  formatDateStartDay,
  formatDateWithOffsetToUTC,
  getEndDate,
  getStartDate,
} from '~/src/dash/utils/date';
import { decorate } from '~/src/dash/utils/decorator';
import {
  deviceEnvironments as deviceEnvs,
  getDeviceEnvironmentSubTypes,
} from '~/src/dash/utils/device-environments';
import { deviceTypes } from '~/src/dash/utils/devices';
import {
  generateEmailParams,
  generateIASQuery,
  generateReportParams,
  getReportGraphID,
  IsExtendedGraph,
  ISQLOption,
  toSQLOption,
} from '~/src/dash/utils/graph';
import { genBiddersMenuList } from '~/src/dash/utils/header-bidder-adapters';
import {
  errorColor,
  growGrid,
  growGridLeft,
  growGridRight,
} from '~/src/dash/utils/material-dashboard-react';
import { filterSiteByPrebid } from '~/src/dash/utils/models';
import { obfuscateCampaignName, obfuscateOrderName } from '~/src/dash/utils/obfuscate';
import {
  allowedEmptyIPermissionCheck,
  IPermissionCheck,
  IS_AUTHORIZED,
} from '~/src/dash/utils/permission_service';
import {
  adomainFilterMetrics,
  DATE_RANGE_NOT_ALLOWED,
  frequency,
  FrequencyMonthly,
  FrequencyWeekly,
  generateBidderTierMenuList,
  generateTrueFalseMenuList,
  getColumnIndex,
  getGroupColumnsByReportID,
  getMetricColumnsByReportID,
  getReportHeaderBidderTypes,
  GROUP_BY_NOT_ALLOWED_FOR_PREVIEW,
  IColumn,
  period,
  PERIOD_NOT_ALLOWED,
  PLEASE_USE_EMAIL,
  scheduledDayMonthly,
  scheduledDayWeekly,
  SELECT_GROUP_BY_AND_METRIC,
  superUserOnlyMetrics,
} from '~/src/dash/utils/report-fields';
import { checkUserInfoMasked, hasRoleSuperUser } from '~/src/dash/utils/roles';
import { routeName } from '~/src/dash/utils/routes';
import { ICountryState, usStates } from '~/src/dash/utils/states';
import { IStreamType, streamTypes } from '~/src/dash/utils/stream-types';
import { isCreativeTagEventsEnabled } from '~/src/dash/utils/ui';
import { hasErrors, IErrors, validatorFactory } from '~/src/dash/utils/validator';
import { ButtonView } from '~/src/dash/views/button-view';
import { H1, H2, RowButton } from '~/src/dash/views/component-view';
import { FormRecipientView } from '~/src/dash/views/form-email-view';
import { SelectOrderByView } from '~/src/dash/views/select-order-by-view';
import { SnackbarView } from '~/src/dash/views/snackbar-view';

export interface IDedupMap {
  [key: string]: boolean;
}

interface IProps
  extends IWithStylesProps,
    IReduxActionProps,
    ISessionStateProps,
    IUserStateProps,
    IHistoryProps {
  report: IReport;
}

interface IState extends IBaseState, IReport {
  dateStart: moment.Moment;
  dateEnd: moment.Moment;
  data: any;
  bidderGroups: IBidderGroup[];
  bidders: IHeaderBidder[];
  fwPublisherIDs: number[];
  sites: ISite[];
  channelGroups: IChannelGroup[];
  channelLabels: IChannelLabel[];
  quickFilterOptions: Array<{ title: string; optionItems: IMenuList; type: string }>;
  campaigns: IAdserverCampaign[];
  orders: IAdserverOrder[];
  segments: IAudienceSegment[];
  updating: boolean;
  countUpdating: number;
  errors: IErrors;
  sending: boolean;
  countSending: number;
  snackbarMessage: string;
  snackbarError: boolean;
  statesList: IMenuList; // state list - used for the state filter dropdown
  reportTypesList: IMenuList; // report types list - used for the 'report type' dropdown
  isPresetAggregateSelected: boolean; // is a preset aggregate selected in unique user report group-bys - used to disable date range selection
  availableGroupBys: ISQLOption[]; // group by available for current report - used in Group By dropdown
  countriesList: IMenuList;
  countryGroupsList: IMenuList;
  campaignsList: IMenuList;
  bidderTierFilterList: IMenuList;
  lineItemAliasesList: IMenuList;
  orderAliasesList: IMenuList;
  ordersList: IMenuList;
  destinationList: IMenuList;
  inventoryRouteList: IMenuList;
  loadingCampaigns: boolean;
  loadingChannels: boolean;
  loadingChannelGroupsAndLabels: boolean;
  loadingBidders: boolean;
  loadingBidderGroupsAndLabels: boolean;
  loadingOrders: boolean;
  loadingOrderAliases: boolean;
  loadingLineItemAliases: boolean;
  bidderCodesList: IMenuList;
  ssp: string;
  BidderTierFilter: string;
  Adomains: string;
  DealIDs: string;
  CampaignIDs: string[];
  networks: INetwork[];
  networksList: IMenuList;
  NetworkIDs: string[];
  streamTypesList: IMenuList;

  readAuthorization: IPermissionCheck;
  writeAuthorization: IPermissionCheck;
  isSendNowWarningOpen: boolean;
  ReportFilterConfig: IReportFilterConfig;

  IsSiteIDsIncluded: EBool;
  IsBidderIDsIncluded: EBool;
  OrderAliases: string[];
  LineItemAliases: string[];
  selectedLineItemAliases: string[];
  selectedOrderAliases: string[];
  s3AccessPoint: IS3AccessPoint;
}

function isExistingReport(report: IReport) {
  return !!report.ID;
}

const validate = validatorFactory({
  ReportType(val: any): string {
    if (!val) {
      return 'Select a report type';
    }
    return '';
  },
  Metrics(val: any, _key: string, _obj: IObject): string {
    if (reportsWithoutMetrics.includes(_obj.ReportType)) return '';
    if ((!val || !val.length) && !reportsWithoutMetrics.includes(_obj.ReportType)) {
      return 'Select a report metric';
    }
    return '';
  },
  GroupByOptions(val: any, _key: string, _obj: IObject): string {
    if (reportsWithoutGroupBy.includes(_obj.ReportType)) return '';
    if (!val || !val.length) {
      return 'Select a report groupby option';
    }
    return '';
  },
  Name(val: any): string {
    if (!val) {
      return 'Enter a custom report name';
    }
    return '';
  },
  ReportLimit(val: any): string {
    if (val && isNaN(parseInt(val, 10))) {
      return 'Please enter a valid number';
    }
    return '';
  },
  Subject(val: any): string {
    if (!val) {
      return 'Enter a custom email subject line';
    }
    return '';
  },
  Frequency(val: any): string {
    if (!val) {
      return "Select the report data's frequency";
    }
    return '';
  },
  Period(val: any): string {
    if (!val) {
      return "Select a report data's period";
    }
    return '';
  },
});

const commonAuctionRegex =
  /(VMAP Requests|VMAP Responses|Bid Requests|Bid Responses|^Winning Bids|^(?!.*Line Item).*Impressions|Lost Bids|Publica Endpoint Requests|Publica Endpoint Responses|Auctions|^Event Endpoint Errors|^Completes$)/;
const rokuAuctionRegex =
  /(Bid Requests|Bid Responses|^Winning Bids|Impressions|Lost Bids|Endpoint Requests|Endpoint Responses|Auctions|^Event Endpoint Errors|^Completes$)/;

interface ILiveStreamSelectOption {
  text: string;
  value: number;
}

export const iasFirstPartyDeviceTypes: Array<{ key: string; text: string }> = [
  {
    key: '111|112',
    text: 'Desktop Web',
  },
  {
    key: '121|122',
    text: 'Mobile Web',
  },
  {
    key: '131|132',
    text: 'Tablet Web',
  },
  {
    key: '221|222',
    text: 'Mobile App',
  },
  {
    key: '231|232',
    text: 'Tablet App',
  },
  {
    key: '252',
    text: 'CTV App',
  },
];

export const iasThirdPartyDeviceTypes: Array<{ key: string; text: string }> = [
  {
    key: '111|112',
    text: 'Desktop Web',
  },
  {
    key: '121|122',
    text: 'Mobile Web',
  },
  {
    key: '131|132',
    text: 'Tablet Web',
  },
  {
    key: '221|222',
    text: 'Mobile App',
  },
  {
    key: '231|232',
    text: 'Tablet App',
  },
  {
    key: '252',
    text: 'CTV App',
  },
  {
    key: '152',
    text: 'CTV Web',
  },
];

const livestreamSelectOptions = [
  {
    text: 'VOD',
    value: 0,
  },
  {
    text: 'Live',
    value: 1,
  },
  {
    text: 'DVR',
    value: 2,
  },
] as ILiveStreamSelectOption[];

// Metrics and Group-bys white-listed for use with WOY grouping
const woyWhitelistedMetricParams: string[] = [
  'auction_clear_rate',
  'auction_latency',
  'avg_bid',
  'avg_imp_ecpm',
  'avg_imp_gross_ecpm',
  'avg_winning_bid',
  'bid_auctions',
  'bid_errors',
  'bid_error_rate',
  'bid_losts',
  'BidLossRatePrice',
  'BidLossRateTier',
  'bid_none',
  'bid_requests',
  'bid_responses',
  'bid_response_rate',
  'bid_timeouts',
  'bid_wons',
  'buyers_latency',
  'campaign_complete',
  'campaign_filled',
  'campaign_impression',
  'campaign_inventory_request',
  'campaign_no_fill',
  'campaign_quartile1',
  'campaign_quartile2',
  'campaign_quartile3',
  'campaign_request',
  'campaign_start',
  'complete',
  'completion_rate',
  'delivered_pod_duration',
  'event_endpoint_errors',
  'endpoint_requests',
  'endpoint_latency',
  'endpoint_responses',
  'filled_pod_duration',
  'fillrate',
  'pod_clear_rate',
  'gross_revenue',
  'impressions',
  'revenue',
  'render_rate',
  'render_rate_by_pod_duration',
  'requested_pod_duration',
  'win_rate',
  'vast_errors',
  'bid_timeouts_rate',
];

const woyWhitelistedGroupByParams: string[] = [
  'active_bidder_tier',
  'adomain',
  'ad_duration',
  'advertiser_name',
  'agency_name',
  'app_bundle_id',
  'app_name',
  'brand_safety_rule_id',
  'biddername',
  'bid_error_code',
  'bid_density',
  'bidder_tier',
  'bidder_group',
  'bidder_testing',
  'bidder_type',
  'campaignname',
  'category',
  'channel_group',
  'city',
  'country',
  'content_cat',
  'content_channel',
  'content_context',
  'content_dist_id',
  'content_dist_name',
  'content_episode',
  'content_genre',
  'content_id',
  'content_keywords',
  'content_language',
  'content_length',
  'content_network',
  'content_prodqual',
  'content_producer_id',
  'content_producer_name',
  'content_rating',
  'content_season',
  'content_series',
  'content_title',
  'creative_id',
  'creative_name',
  'custom1',
  'custom4',
  'custom5',
  'custom6',
  'custom7',
  'custom8',
  'custom9',
  'custom10',
  'custom11',
  'custom12',
  'custom13',
  'custom14',
  'custom15',
  'custom16',
  'custom17',
  'custom18',
  'custom_targeting',
  'deal_id',
  'demand_path',
  'delivered_ads',
  'devicetype',
  'dma',
  'do_not_track',
  'endpoint_error_code',
  'filled_ads',
  'fw_section_name',
  'fw_section_id_v2',
  'gdpr',
  'gdpr_consent',
  'ip_type',
  'line_item_status',
  'livestream',
  'no_fill_reason',
  'operating_system',
  'order_name',
  'ortb_site_name',
  'philo_fallback',
  'pod_duration',
  'publisher_name',
  'salesperson_name',
  'siteid',
  'sitename',
  'spotx_param_channel_id',
  'state',
  'targeting_device',
  'trafficker_name',
  'us_privacy',
  'vast_error_code',
  'week_of_year',
  'zip',
];

const reportsWithDeviceEnvironmentFilter = [
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_BUYERS_APS,
];

const reportsWithDeviceSubtypeFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_BUYERS_APS,
];
const reportsWithDeviceTypeFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithDestinationFilter = [
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithInventoryRouteFilter = [
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithChannelGroupFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithChannelFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_TTD,
  REPORTTYPE_POD_HOURLY,
  REPORTTYPE_ADVERTISER_RULES,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithBidderIDFilter = [
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_CREATIVE_VALIDATION,
  REPORTTYPE_TTD,
  REPORTTYPE_CREATIVE_REVIEW,
  REPORTTYPE_SHARE_OF_VOICE,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_BID_FLOOR_SETTINGS_REPORT,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithBidderGroupFilter = [
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_CONTEXTUAL_SEGMENTS,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_BUYERS_APS,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithDemandSourceFilter = [
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_TTD,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithCountryFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_SCAN_ALL,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_ENRICHMENT,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithStateFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_CAMPAIGN,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_SCAN_ALL,
  REPORTTYPE_HEADERBIDDER_ELEA_AI_ENRICHMENT,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
];

const reportsWithCountryGroupFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
  REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE,
  REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER,
  REPORTTYPE_HEADERBIDDER_DEALS,
  REPORTTYPE_HEADERBIDDER_PUBLICA_DEALS,
  REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
  REPORTTYPE_HEADERBIDDER_DESTINATIONS,
  REPORTTYPE_FAST_AUCTION,
  REPORTTYPE_FAST_BIDDER,
];

const reportsWithChannelLabelFilter = [
  REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
  REPORTTYPE_HEADERBIDDER_BYBUYERS,
];

const reportsWithIASDeviceTypeFilter = [REPORTTYPE_IAS_FIRST_PARTY, REPORTTYPE_IAS_THIRD_PARTY];

const reportsWithOrderAliasesFilter = [REPORTTYPE_HEADERBIDDER_CAMPAIGN];

const reportsWithLineItemAliasesFilter = [REPORTTYPE_HEADERBIDDER_CAMPAIGN];

const reportsWithAdvertiserIDFilter = [REPORTTYPE_HEADERBIDDER_BYBUYERS];

const reportsWithBidderTierFilter = [REPORTTYPE_HEADERBIDDER_BYBUYERS, REPORTTYPE_FAST_BIDDER];

const publisherIDsWithAdvertiserRulesFilter = ['381'];

// this special report type does not require any date range, timezone, currency, metrics or groupBys. It is a simple report of Publica UI settings (eg. bidder settings to show bid_floor per bidder)
const reportsPublicaSettingsReport = [REPORTTYPE_BID_FLOOR_SETTINGS_REPORT];

const reportsWithoutFilters = [REPORTTYPE_BID_SAVER_TRUE_LIFT];
const reportsWithoutMetrics = [] as ReportType[];
const reportsWithoutGroupBy = [] as ReportType[];
const reportsWithoutOrderBy = [] as ReportType[];

export const BidderReportFormView = decorate(
  {
    redux: (state: IStore) => {
      return {
        user: state.user,
        session: state.session,
      };
    },
    styles: (theme: any) => ({
      paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
      },
      siteSelectButton: {},
      reportNameContainer: {
        display: 'inline-block',
        width: 'calc(50% - 2em)',
      },
      section: {
        display: 'block',
        marginBottom: theme.spacing.unit * 4,
      },
      button: {
        margin: theme.spacing.unit,
      },
      datePickerSection: {
        display: 'inline-flex',
        'justify-content': 'center',
        'align-items': 'center',
      },
      growGrid,
      growGridLeft,
      growGridRight,
      errorColor: {
        color: errorColor,
      },
      filterInput: { width: '850px', height: '68px' },
    }),
    router: true,
  },
  class extends React.Component<IProps, IState> {
    state = (() => {
      return Object.assign(cloneDeep(this.props.report), {
        dateStart: getStartDate(this.props.report.Timezone || 'UTC', 6, 'day').startOf('day'),
        dateEnd: getEndDate(this.props.report.Timezone || 'UTC').endOf('day'),
        bidderGroups: [] as IBidderGroup[],
        bidderLabels: [] as IBidderLabel[],
        sites: [] as ISite[],
        channelGroups: this.props.session.channelGroups,
        channelLabels: [] as IChannelLabel[],
        quickFilterOptions: [] as Array<{ title: string; optionItems: IMenuList; type: string }>,
        bidders: [],
        fwPublisherIDs: [],
        campaigns: [] as IAdserverCampaign[],
        orders: [] as IAdserverOrder[],
        segments: [] as IAudienceSegment[],
        updating: false,
        countUpdating: 0,
        errors: {} as IErrors,
        sending: false,
        countSending: 0,
        data: [],
        snackbarMessage: '',
        snackbarError: false,
        SiteIDs: this.props.report.SiteIDs || [],
        channelList: {} as IMenuList,
        ChannelGroupIDS: (this.props.report.ChannelGroups || []).map((cg) => cg.ID) || [],
        channelGroupsList: {} as IMenuList,
        timezonesList: {} as IMenuList,
        currencyList: {} as IMenuList,
        bidderList: {} as IMenuList,
        bidderGroupsList: {} as IMenuList,
        bidderLabelsList: {} as IMenuList,
        inventoryRouteList: {} as IMenuList,
        InventoryRouteIDs: this.props.report.InventoryRouteIDs || [],
        destinationList: {} as IMenuList,
        DestinationIDs: this.props.report.DestinationIDs || [],
        BidderIDs: this.props.report.BidderIDs || [],
        BidderGroupsIDs: this.props.report.BidderGroupsIDs || [],
        Metrics: this.props.report.Metrics || [],
        statesList: {} as IMenuList,
        reportTypesList: getReportHeaderBidderTypes(
          this.props.session.publisher,
          this.props.user.user,
          [],
          false,
          false,
        ),
        isPresetAggregateSelected: false, // by default no preset aggregate is selected
        availableGroupBys: [],
        countriesList: generateCountriesMenuList(),
        countryGroupsList: {} as IMenuList,
        channelLabelsList: {} as IMenuList,
        campaignsList: {} as IMenuList,
        ordersList: {} as IMenuList,
        lineItemAliasesList: {} as IMenuList,
        orderAliasesList: {} as IMenuList,
        loadingCampaigns: true,
        loadingChannels: true,
        loadingChannelGroupsAndLabels: true,
        loadingBidders: true,
        loadingBidderGroupsAndLabels: true,
        loadingLineItemAliases: true,
        loadingOrders: true,
        loadingOrderAliases: true,
        bidderCodesList: {} as IMenuList,
        ssp: '',
        CampaignIDs: this.props.report.CampaignIDs,
        loadingNetworks: false,
        networks: [] as INetwork[],
        networksList: {} as IMenuList,
        NetworkIDs: this.props.report.NetworkIDs,

        streamTypesList: {} as IMenuList,
        StreamTypes: this.props.report.StreamTypes,
        IsPartialAdBreakList: generateTrueFalseMenuList(),
        IsPartialAdBreak: '',

        readAuthorization: allowedEmptyIPermissionCheck,
        writeAuthorization: allowedEmptyIPermissionCheck,
        States: this.props.report.States,
        DMAs: this.props.report.DMAs,
        ReportFilterConfig:
          this.props.report.ReportFilterConfig ||
          ({ ...defaultReportFilterConfig } as IReportFilterConfig),
        isSendNowWarningOpen: false,
        DeviceSubtypes: this.props.report.DeviceSubtypes || [],
        IASAnID: '',
        bidderTierFilterList: generateBidderTierMenuList(this.props.report),
        BidderTierFilter: this.props.report.BidderTierFilter || '',
        IsSiteIDsIncluded: this.props.report.IsSiteIDsIncluded || 2,
        IsBidderIDsIncluded: this.props.report.IsBidderIDsIncluded || 2,
        LineItemAliases: this.props.report.LineItemAliases || [],
        OrderAliases: this.props.report.OrderAliases || [],
        selectedLineItemAliases: [],
        selectedOrderAliases: [],
        s3AccessPoint: {} as IS3AccessPoint,
      });
    })();

    _saveReport = debounce((countUpdating: number, fromScheduled?: boolean) => {
      if (countUpdating !== this.state.countUpdating) {
        this.setState({
          updating: false,
        });
        return;
      }
      // validateForm updates the snackbar state if it returns false
      if (!this.validateForm(ReportRetrieveMethodEmail, 'Saving report')) {
        this.setState({
          updating: false,
        });
        return;
      }
      (isExistingReport(this.state) ? updateReport : createReport)({
        query: Object.assign(
          {
            publisher_id: this.props.session.publisher.ID,
            report: this.cleanReportStateByReportType(this.state.ReportType),
          },
          isExistingReport(this.state)
            ? {
                report_id: this.state.ID,
              }
            : {},
        ),
      }).then(
        (report: IReport) => {
          this.trackEvent(
            fromScheduled
              ? 'Report - Schedule Report'
              : isExistingReport(this.state)
              ? 'Report - Save Report'
              : 'Report - Create Report',
          );
          navigate(RouteBidderReportsExisting, extractRouteParams(this.props), {
            reportID: report.ID,
          });
          this.setState(
            Object.assign(this.state, report, {
              snackbarMessage: 'Successfully saved report',
              snackbarError: false,
              updating: false,
            }),
          );
          this.refreshExchangeRate(report);
        },
        (err: Error) => {
          this.setState({
            snackbarMessage: err.toString(),
            snackbarError: true,
            updating: false,
          });
        },
      );
    }, 500);

    _sendEmail = debounce(
      (countSending: number, useStartEndDate: boolean, isEmailToSelf: boolean) => {
        if (countSending !== this.state.countSending) {
          return;
        }
        // validateForm updates the snackbar state if it returns false
        if (
          !this.validateForm(
            isEmailToSelf ? ReportRetrieveMethodEmail : ReportRetrieveMethodSchedule,
            'Sending report email',
          )
        ) {
          this.setState({
            sending: false,
          });
          return;
        }
        const sendEmail = this._getSendEmail(useStartEndDate);
        sendEmail.then(
          () => {
            this.trackEvent(useStartEndDate ? 'Report - Send Email' : 'Report - Send Now');
            if (countSending !== this.state.countSending) {
              return;
            }
            this.setState({
              snackbarMessage: useStartEndDate
                ? 'The report is on the way.'
                : 'The scheduled report is on the way to the recipient(s).',
              snackbarError: false,
              sending: false,
            });
          },
          (err: any) => {
            if (countSending !== this.state.countSending) {
              return;
            }
            if (err.msg) {
              this.setState({
                sending: false,
                snackbarMessage: err.msg,
                snackbarError: true,
              });
            } else if (err.error) {
              this.setState({
                sending: false,
                snackbarMessage: err.error.toString() || 'Error',
                snackbarError: true,
              });
            } else {
              this.setState({
                sending: false,
                snackbarMessage: 'Error',
                snackbarError: true,
              });
            }
          },
        );
      },
      200,
    );

    _scheduleReport = debounce((countSending: number) => {
      if (countSending !== this.state.countSending) {
        return;
      }
      // validateForm updates the snackbar state if it returns false
      if (!this.validateForm(ReportRetrieveMethodSchedule, 'Schedule report email')) {
        this.setState({
          sending: false,
        });
        return;
      }

      scheduleReport({
        query: generateEmailParams(this.state, {
          publisher_id: this.props.session.publisher.ID,
          report_name: this.state.Name,
          start_date: '',
          end_date: '',
          timezone: this.state.Timezone,
          currencydisplayed: this.getCurrencyDisplayed(),
          email: this.props.user.user.Username,
        }),
      }).then(
        () => {
          if (countSending !== this.state.countSending) {
            return;
          }
          this.setState({
            snackbarMessage: 'Please allow 5 minutes for your report to be sent to the recipients.',
            snackbarError: false,
            sending: false,
          });
        },
        (err: any) => {
          if (countSending !== this.state.countSending) {
            return;
          }
          if (err.msg) {
            this.setState({
              sending: false,
              snackbarMessage: err.msg,
              snackbarError: true,
            });
          } else if (err.error) {
            this.setState({
              sending: false,
              snackbarMessage: err.error.toString() || 'Error',
              snackbarError: true,
            });
          } else {
            this.setState({
              sending: false,
              snackbarMessage: 'Error',
              snackbarError: true,
            });
          }
        },
      );
    }, 200);

    _generateIASQuery = (useStartEndDate: boolean): IIASFirstAndThirdPartyRequestBody => {
      // parse device types
      const DeviceTypes = [];
      for (const deviceTypes of this.state.DeviceTypes) {
        for (const deviceType of deviceTypes.split('|')) {
          DeviceTypes.push(parseInt(deviceType, 10));
        }
      }
      const IASAnID = Number(this.state.IASAnID)
        ? Number(this.state.IASAnID)
        : this.props.session.publisher.IASAnID;
      return generateIASQuery(this.state, {
        StartDate: useStartEndDate ? formatDateStartDay(this.state.dateStart) : '',
        EndDate: useStartEndDate ? formatDateEndDay(this.state.dateEnd) : '',
        Timezone: this.state.Timezone,
        Email: useStartEndDate ? this.props.user.user.Username : '',
        // Debug: hasRoleSuperUser(this.props.user.user),
        Debug: false,
        AnID: IASAnID, // before release to all user, remove this
        OrderIDs: [], // blank until we add ability for filter dropdowns
        CreativeIDs: [], // blank until we add ability for filter dropdowns
        DeviceTypes,
        LineItemIDs: [], // blank until we add ability for filter dropdowns
        GroupingNumber: this.state.GroupByOptions.includes('month') ? 3 : 1,
        Priority: useStartEndDate ? '' : '5',
      });
    };

    _getSendEmail = (useStartEndDate: boolean): Promise<unknown> => {
      // If the report is an IAS Report we do use a different query/route
      if (isIASReport(this.state.ReportType)) {
        return sendIASEmail(
          this._generateIASQuery(useStartEndDate),
          generateEmailParams(this.state, {
            graph_id: this.getReportGraphID(),
            publisher_id: this.props.session.publisher.ID,
            report_name: this.state.Name,
            start_date: useStartEndDate ? formatDateStartDay(this.state.dateStart) : '',
            end_date: useStartEndDate ? formatDateEndDay(this.state.dateEnd) : '',
            timezone: this.state.Timezone,
            currencydisplayed: this.getCurrencyDisplayed(),
            email: useStartEndDate ? this.props.user.user.Username : '',
            priority: useStartEndDate ? '' : '5',
          }),
        );
      } else {
        return sendEmail({
          query: generateEmailParams(this.state, {
            publisher_id: this.props.session.publisher.ID,
            report_name: this.state.Name,
            start_date: useStartEndDate ? formatDateStartDay(this.state.dateStart) : '',
            end_date: useStartEndDate ? formatDateEndDay(this.state.dateEnd) : '',
            timezone: this.state.Timezone,
            currencydisplayed: this.getCurrencyDisplayed(),
            email: useStartEndDate ? this.props.user.user.Username : '',
            priority: useStartEndDate ? '' : '5',
          }),
        });
      }
    };

    trackEvent = (eventTitle: ReportingEventTypes): string => {
      const is_super_user = hasRoleSuperUser(this.props.user.user);
      const reportParams = this.generateReportParams(true, false);
      let report_type = '';
      const eventUUID = uuid();
      for (const item of Object.values(this.state.reportTypesList)) {
        if (item.selected) {
          report_type = item.title;
          break;
        }
      }
      if (eventTitle === 'Report - View') {
        track(
          eventTitle,
          {
            is_super_user,
          },
          this.props.user.user,
        );
      } else {
        track(
          eventTitle,
          {
            is_super_user,
            // ids
            event_uuid: eventUUID,
            report_id: this.state.ID,
            report_name: this.state.Name,
            report_type,
            subject: this.state.Subject,
            recipients: this.state.Recipients,
            // group bys and metrics
            metrics:
              reportParams.metrics === '' ? [] : cleanCommaSeparatedString(reportParams.metrics),
            groupbyoptions:
              reportParams.groupbyoptions === ''
                ? []
                : cleanCommaSeparatedString(reportParams.groupbyoptions),
            // date info
            start_date: reportParams.start_date,
            end_date: reportParams.end_date,
            report_duration_days: this.state.dateEnd.diff(this.state.dateStart, 'days'),
            // ids
            channel_group_ids:
              reportParams.channel_group_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.channel_group_ids),
            site_ids:
              reportParams.site_ids === '' ? [] : cleanCommaSeparatedString(reportParams.site_ids),
            bidder_ids:
              reportParams.bidder_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.bidder_ids),
            campaign_ids:
              reportParams.campaign_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.campaign_ids),
            segment_ids:
              reportParams.segment_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.segment_ids),
            network_ids:
              reportParams.network_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.network_ids),
            inventory_route_ids:
              reportParams.inventory_route_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.inventory_route_ids),
            destination_ids:
              reportParams.destination_ids === ''
                ? []
                : cleanCommaSeparatedString(reportParams.destination_ids),
            // other filters
            stream_types:
              reportParams.stream_types === ''
                ? []
                : cleanCommaSeparatedString(reportParams.stream_types),
            deviceenvs:
              reportParams.deviceenvs === ''
                ? []
                : cleanCommaSeparatedString(reportParams.deviceenvs),
            devicetypes:
              reportParams.devicetypes === ''
                ? []
                : cleanCommaSeparatedString(reportParams.devicetypes),
            device_subtypes:
              reportParams.device_subtypes === ''
                ? []
                : cleanCommaSeparatedString(reportParams.device_subtypes),
            biddercodes:
              reportParams.biddercodes === ''
                ? []
                : cleanCommaSeparatedString(reportParams.biddercodes),
            currencydisplay:
              reportParams.currency === undefined
                ? this.props.session.publisher.CurrencyDisplayed
                : reportParams.currency,
            countries:
              reportParams.countries === ''
                ? []
                : cleanCommaSeparatedString(reportParams.countries),
            dmas: reportParams.dmas === '' ? [] : cleanCommaSeparatedString(reportParams.dmas),
            states:
              reportParams.states === '' ? [] : cleanCommaSeparatedString(reportParams.states),
            report_limit: reportParams.report_limit,
            report_order_by: reportParams.report_order_by,
            timezone: reportParams.timezone,
            order_aliases:
              reportParams.order_aliases === ''
                ? []
                : cleanCommaSeparatedString(reportParams.order_aliases),
            line_item_aliases:
              reportParams.line_item_aliases === ''
                ? []
                : cleanCommaSeparatedString(reportParams.line_item_aliases),
            // scheduling
            scheduled_day: this.state.ScheduledDay,
            frequency: this.state.Frequency,
            period: this.state.Period,
          },
          this.props.user.user,
        );
      }
      return eventUUID;
    };

    refreshExchangeRate = (report: IReport) => {
      if (report.ReportType === REPORTTYPE_TTD) {
        this.setState({
          currencyList: {
            'US Dollar': {
              ID: 'US Dollar',
              title: 'US Dollar',
              selected: true,
              defaultWeight: 0,
            },
          },
        });
      } else {
        getExchangeRate(report.CurrencyDisplayed)
          .then((exchange: IExchangeRate) => {
            this.setState({
              ExchangeRate: exchange || report.ExchangeRate,
              currencyList: genCurrencyList(report.CurrencyDisplayed),
            });
          })
          .catch(() => {
            this.setState({
              // snackbarMessage: 'Unable to retrieve exchange rate. Defaulting to previous one.',
              // snackbarError: true,
              ExchangeRate: report.ExchangeRate,
              currencyList: genCurrencyList(report.CurrencyDisplayed),
            });
          });
      }
    };

    refreshS3AccessPoint() {
      const isReportTTD =
        this.state.ReportType === REPORTTYPE_TTD ? EBool.EBool_TRUE : EBool.EBool_FALSE;
      getS3AccessPoint(this.props.session.publisher.ID, isReportTTD).then(
        (val: IHttpResponse<IS3AccessPoint>) => {
          this.setState({
            s3AccessPoint: val.parsedBody as IS3AccessPoint,
          });
        },
      );
    }

    componentDidMount() {
      this.trackEvent('Report - View');
      this.setState({
        readAuthorization: IS_AUTHORIZED(['read_report'], this.props.user.user),
        writeAuthorization: IS_AUTHORIZED(['write_report'], this.props.user.user),
      });

      if (getResellerID() > 0) {
        getReseller({
          query: {
            reseller_id: getResellerID(),
          },
        }).then((reseller: IReseller) => {
          this.setState({
            ssp: reseller.SSP,
          });
        });
      }

      // populate timezone list
      let timezonesList: IMenuList;
      if (this.state.ReportType === REPORTTYPE_TTD) {
        timezonesList = {
          UTC: {
            title: 'UTC',
            ID: 'UTC',
            selected: true,
          },
        };
      } else {
        timezonesList = genTimezoneList(
          this.state.Timezone || this.props.session.publisher.Timezone,
        );
      }
      this.setState({
        timezonesList,
      });

      // populate currency list
      this.refreshExchangeRate(this.props.report);
      this.getBidderInfo();
      this.getChannelInfo();
      this.getCampaigns();
      this.getOrders();
      this.getNetworks();
      this.getAudienceSegments();
      this.getInventoryRoutesAndDestinations();
      this.getCountryGroups();
      this.refreshS3AccessPoint();

      // get unique order and line item aliases
      this.handleGetUniqueOrderAliases();
      this.handleGetUniqueLineItemAliases();

      // get the available group bys and metrics for the current report
      this.updateAvailableGroupBysAndMetrics();

      Promise.all([
        getFWPublisherIDs(),
        getPublisherAdQualityStatus(parseInt(this.props.session.publisher.ID, 10)),
      ])
        .then((resp) => {
          const [fwPublisherIDs, publisherAdQualityStatus] = resp;
          const [hasPublisherEnabledBrandRecognition, hasPublisherEnabledLanguageDetection] =
            publisherAdQualityStatus;
          this.setState(
            {
              fwPublisherIDs,
              reportTypesList: getReportHeaderBidderTypes(
                this.props.session.publisher,
                this.props.user.user,
                fwPublisherIDs,
                !!hasPublisherEnabledBrandRecognition,
                !!hasPublisherEnabledLanguageDetection,
              ),
            },
            () => {
              this.updateReportTypeAndLists();
            },
          );
        })
        .catch(() => {
          this.setState(
            {
              fwPublisherIDs: [],
            },
            () => {
              this.updateReportTypeAndLists();
            },
          );
        });
    }

    handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      if (target.name === 'ReportType') {
        this.setState({
          Adomains: '',
          DealIDs: '',
          ReportLimit: '',
          Metrics: [],
          CurrencyDisplayed: 0,
          Countries: [],
          DeviceEnvs: [],
          DeviceTypes: [],
          DeviceSubtypes: [],
          BidderIDs: [],
          BidderCodes: [],
          CampaignIDs: [],
          NetworkIDs: [],
          ChannelGroupIDS: [],
          SegmentIDs: [],
          GroupByOptions: [],
          StreamTypes: [],
          VenueIDs: '',
          BidderTierFilter: '',
          LineItemAliases: [],
          OrderAliases: [],
          ReportFilterConfig: { ...defaultReportFilterConfig } as IReportFilterConfig,
        });
      }

      if (target.name === 'DealIDs' && target.value.toLowerCase() === 'none') {
        target.value = target.value.toLowerCase();
      }

      this.setState(
        {
          [target.name]:
            target.name === 'SuperOnly'
              ? target.value === 'true'
                ? SuperOnlyInactive
                : SuperOnlyActive
              : target.value,
        },
        () => {
          if (hasErrors(this.state.errors)) {
            this.validateForm(ReportRetrieveMethodUnknown);
          }
        },
      );
    };

    handleChangeReportFilterConfig = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const reportFilterConfig = cloneDeep(this.state.ReportFilterConfig);
      if (target.name === 'AdvertiserIDs') {
        const advertiserIDs = target.value.split(',').map((advertiserID) => {
          return advertiserID.trim();
        });
        reportFilterConfig.AdvertiserIDs = advertiserIDs;
      }

      this.setState(
        {
          ReportFilterConfig: reportFilterConfig,
        },
        () => {
          if (hasErrors(this.state.errors)) {
            this.validateForm(ReportRetrieveMethodUnknown);
          }
        },
      );
    };

    // handles a change for the adomain filter (auctions & bidder reports only)
    // 1. when there is a value for this filter, it will use the extended report
    // 2. because the adomain is not known for some events (the ones logged before
    //    it), we cannot calculate some of the metrics without increasing the
    //    time it takes for the cron jobs to finish processing the pig scripts
    // 3. we will filter the metrics down when there is input in this field
    handleChangeAdomain = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      const { Metrics } = this.state;
      const filteredMetrics = Metrics.filter((metric) => adomainFilterMetrics.includes(metric));
      this.setState({
        [target.name]: target.value,
        Metrics: filteredMetrics,
      });
    };

    handleChangeOrderBy = (orderBy: string) => {
      this.setState({ ReportOrderBy: orderBy });
    };

    // handle change on the DMA textfield component
    handleChangeNumber = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
      this.setState({
        [target.name]: target.value,
      });
    };

    handleReportFilterConfigInputChange = (elem: React.ChangeEvent<HTMLInputElement>): void => {
      const { type, name: path, value, checked } = elem.target;
      let parsedValue;
      switch (type) {
        // for input[type=number] fields
        case 'number':
          parsedValue = parseInt(value, 10);
          break;
        // <Checkbox/> returned a boolean on the checked property of the target
        case 'checkbox':
          parsedValue = checked;
          break;
        // Everything else including <input> fields return strings
        default:
          parsedValue = value;
      }

      // Create a new ReportFilterConfig so that we can bubble up change
      const newReportFilterConfig = { ...this.state.ReportFilterConfig };
      set<IReportFilterConfig>(newReportFilterConfig, path, parsedValue);

      this.setState(
        {
          ReportFilterConfig: newReportFilterConfig,
        },
        () => {
          if (path === 'BidderActiveOnly') {
            this.genBidderList(); // refresh selected bidders when bidderActive filter has changed
          }

          if (path === 'ChannelActiveOnly') {
            this.genChannelList();
            if (this.state.ReportType === REPORTTYPE_TTD) {
              this.filterChannelListForTTD();
            }
          }
        },
      );
    };

    handleChangeSelect = (name: string, value: string[]) => {
      if (name === 'IASDeviceTypes') {
        const iasDeviceTypes = [];
        for (const val of value) {
          if (val.length > 0) {
            iasDeviceTypes.push(...val.split(','));
          }
        }
        this.setState(
          {
            DeviceTypes: value,
            iasDeviceTypes,
          },
          () => {
            if (hasErrors(this.state.errors)) {
              this.validateForm(ReportRetrieveMethodUnknown);
            }
          },
        );
      } else {
        this.setState(
          {
            [name]: value,
          },
          () => {
            if (hasErrors(this.state.errors)) {
              this.validateForm(ReportRetrieveMethodUnknown);
            }
          },
        );
      }
    };

    handleChangeSelectWithSorting = (name: string, value: string[], selection: IColumn[]) => {
      this.handleChangeSelect(
        name,
        value.sort((k1: string, k2: string) => {
          return getColumnIndex(k1, selection) - getColumnIndex(k2, selection);
        }),
      );
    };

    handleDateChange = ({ start, end }: IDateRangeChangeEvent) => {
      this.setState(
        {
          dateStart: start,
          dateEnd: end,
        },
        this.getCampaigns,
      );
    };

    handleChangeRecipients = (Recipients: string[]) => {
      this.setState({
        Recipients,
      });
    };

    handleChangeShouldUploadToExternalS3 = () => {
      this.setState({
        ShouldUploadToExternalS3:
          this.state.ShouldUploadToExternalS3 === EBool.EBool_TRUE
            ? EBool.EBool_FALSE
            : EBool.EBool_TRUE,
      });
    };

    handleChangeActive = () => {
      this.setState({
        Active: this.state.Active === ReportActive ? ReportInactive : ReportActive,
      });
    };

    checkWOYDisable = (fields: string[]): boolean => {
      for (const field of fields) {
        if (
          !woyWhitelistedGroupByParams.includes(field) &&
          !woyWhitelistedMetricParams.includes(field)
        ) {
          return true;
        }
      }
      return false;
    };

    // gets bidder groups and bidder labels
    getBidderInfo = () => {
      const getBidderGroupsPromise = getBidderGroups({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      });

      const getBidderLabelPromise = getBidderLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      });

      Promise.all([getBidderGroupsPromise, getBidderLabelPromise])
        .then((response: any[]) => {
          const bidderGroups = response[0] ? response[0].bidderGroups : [];
          const bidderLabels = response[1] ? response[1].bidder_labels : [];
          this.setState({
            bidderGroups,
            bidderLabels,
          });
        })
        .catch(() => {
          this.setState({
            bidderGroups: [],
            bidderLabels: [],
          });
        });
    };

    // gets all the channel related info to generate list for dropdown, has callback for generating
    // including channels, channel_groups, channel_labels
    getChannelInfo = () => {
      const getChannelLabelPromise = getChannelLabels({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      });

      const getChannelsPromise = getSitesPromise({
        publisherIDs: [this.props.session.publisher.ID],
        publisherID: this.props.session.publisher.ID,
      });

      Promise.all([
        getChannelGroupsPromise({
          publisherID: this.props.session.publisher.ID,
        }),
        getChannelLabelPromise,
        getChannelsPromise,
      ])
        .then((response: any[]) => {
          const reportChannelGroups = this.props.report.ChannelGroups || [];
          const reportChannelGroupIDS = reportChannelGroups.map((cg: IChannelGroup) => cg.ID);
          const channelGroupsList: IMenuList = {};
          const ChannelGroupIDS: number[] = [];

          const reportChannelLabelIDs = this.props.report.ReportFilterConfig.ChannelLabelIDs || [];
          const channelLabelsList: IMenuList = {};
          const ChannelLabelIDs: string[] = [];

          // generate channelgroups list for dropdown
          response[0].channelGroups.forEach((cg: IChannelGroup) => {
            const channelGroupName = checkUserInfoMasked(this.props.user.user)
              ? `demo_channelgroup_` + cg.ID
              : `${cg.Name}: (${cg.SitesInfo.length} Sites)`;
            const selected = reportChannelGroupIDS.includes(cg.ID);
            if (selected) {
              ChannelGroupIDS.push(cg.ID);
            }
            channelGroupsList[cg.ID] = {
              title: channelGroupName,
              selected,
              ID: cg.ID.toString(),
            };
          });

          // generate channelLabels list for dropdown
          response[1].channel_labels.forEach((cl: IChannelLabel) => {
            const channelLabelName = `[${cl.ID}] ${cl.Name} (${cl.Sites.length} Sites)`;
            const channelLabelTitle = checkUserInfoMasked(this.props.user.user)
              ? `demo_channellabel_` + cl.ID
              : `${channelLabelName}`;
            const selected = reportChannelLabelIDs.includes(cl.ID);
            if (selected) {
              ChannelLabelIDs.push(cl.ID);
            }
            channelLabelsList[cl.ID] = {
              title: channelLabelTitle,
              selected,
              ID: cl.ID.toString(),
            };
          });
          const ReportFilterConfig: IReportFilterConfig = {
            ...this.state.ReportFilterConfig,
            ChannelLabelIDs,
          };

          this.setState(
            {
              channelGroups: response[0].channelGroups,
              channelLabels: response[1].channel_labels,
              sites: response[2],
              ChannelGroupIDS,
              channelGroupsList,
              loadingChannelGroupsAndLabels: false,
              channelLabelsList,
              ReportFilterConfig,
            },
            () => {
              // generate channel list and headerbidders after channel groups are retrieved
              // since they rely on knowing which channel groups are selected
              this.genChannelList();
              this.getHeaderBidders();
              this.setState({
                quickFilterOptions: genQuickFilter(
                  this.state.channelGroups,
                  this.state.channelLabels,
                  this.props.user.user.Username,
                ),
              });
            },
          );
        })
        .catch(() => {
          this.setState(
            {
              channelGroups: [],
              ChannelGroupIDS: [],
              channelGroupsList: {} as IMenuList,
              channelLabelsList: {} as IMenuList,
              loadingChannelGroupsAndLabels: false,
            },
            () => {
              this.genChannelList();
              this.getHeaderBidders();
            },
          );
        });
    };

    genBidderList = () => {
      const reportBidders = this.props.report.BidderIDs;
      const reportBiddersGroups = this.props.report.BidderGroupsIDs;
      const bidderList: IMenuList = {};
      const bidderGroupsList: IMenuList = {};
      const bidderLabelsList: IMenuList = {};
      const reportBidderLabelIDs = this.props.report.ReportFilterConfig.BidderLabelIDs || [];
      const BidderLabelIDs: string[] = [];

      const shouldMaskInfo = checkUserInfoMasked(this.props.user.user);

      // bidder groups
      this.state.bidderGroups.forEach((bidderGroup: IBidderGroup) => {
        const bidderGroupName = shouldMaskInfo
          ? `demo_biddergroup_` + bidderGroup.ID
          : `${bidderGroup.Name} (${bidderGroup.ID})`;
        bidderGroupsList[bidderGroup.ID] = {
          title: bidderGroupName,
          selected: (reportBiddersGroups || []).includes(bidderGroup.ID),
          ID: bidderGroup.ID,
        };
      });

      // bidder labels
      this.state.bidderLabels.forEach((bidderLabel: IBidderLabel) => {
        const bidderLabelName = shouldMaskInfo
          ? `demo_bidderlabel_` + bidderLabel.ID
          : `${bidderLabel.Name}`;

        const selected = reportBidderLabelIDs.includes(bidderLabel.ID);
        if (selected) {
          BidderLabelIDs.push(bidderLabel.ID);
        }

        bidderLabelsList[bidderLabel.ID] = {
          title: bidderLabelName,
          selected,
          ID: bidderLabel.ID.toString(),
        };
      });
      // add label IDs to report filter config
      const ReportFilterConfig: IReportFilterConfig = {
        ...this.state.ReportFilterConfig,
        BidderLabelIDs,
      };

      // bidders
      const stateBidders: IHeaderBidder[] = this.state.bidders;
      for (const bidder of stateBidders) {
        // filter if not active, deleted or has no targetted sites
        if (
          this.state.ReportFilterConfig.BidderActiveOnly &&
          (bidder.Active !== EBool.EBool_TRUE || bidder.DeletedAt || bidder.SuperOnly)
        ) {
          continue;
        }
        // REPORTTYPE_TTD should be filtered to only trade desk bidders
        if (this.state.ReportType === REPORTTYPE_TTD && bidder.Bidder !== 'thetradedesk') {
          continue;
        }

        const bidderName = shouldMaskInfo ? `demo_bidder_` + bidder.ID : bidder.Name;
        bidderList[bidder.ID] = {
          title: bidderName,
          selected: reportBidders.includes(bidder.ID),
          ID: bidder.ID,
        };
      }

      this.setState({
        bidderList,
        bidderGroupsList,
        bidderLabelsList,
        loadingBidders: false,
        loadingBidderGroupsAndLabels: false,
        ReportFilterConfig,
      });
    };

    filterChannelListForTTD = () => {
      const newChannelList: IMenuList = {};
      this.state.bidders.forEach((bidder: IHeaderBidder) => {
        if (bidder.Bidder === 'thetradedesk') {
          bidder.SiteIDS.forEach((siteId) => {
            newChannelList[siteId] = this.state.channelList[siteId];
          });
        }
      });

      this.setState({
        channelList: newChannelList,
      });
    };

    genChannelList = () => {
      // genChannelList is run at component mount, so state.SiteIDs should be set to this.props.report.SiteIDs
      const reportSiteIDs = this.state.SiteIDs;
      const channelList: IMenuList = {};

      filterSiteByPrebid(this.state.sites).forEach((site: ISite) => {
        // filter out non-active from channelList
        if (this.state.ReportFilterConfig.ChannelActiveOnly) {
          if ((!!site.DeletedAt && site.DeletedAt !== 'null') || site.Active !== SiteActiveActive) {
            return;
          }
        }

        const siteName = checkUserInfoMasked(this.props.user.user)
          ? 'demo_site_' + site.ID
          : site.Name;
        const idString = site.ID.toString();
        channelList[site.ID] = {
          title: siteName,
          selected: reportSiteIDs.includes(site.ID.toString()),
          ID: idString,
        };
      });
      this.setState({
        channelList,
        loadingChannels: false,
      });
    };

    getHeaderBidders = () => {
      // get all header bidders for selected channel groups and sites
      // Need to dedup these two sets of site IDs
      const channelGroupSiteIDs = {} as IDedupMap;
      const allSiteIDs = [];
      // List of all selected individual Site IDs and Site IDs from selected channel groups
      let allCGAndIndividualSiteIDs = [];

      // iterate over selected site ids
      for (const siteID of this.state.SiteIDs) {
        if (!(siteID in channelGroupSiteIDs)) {
          channelGroupSiteIDs[siteID] = true;
          allSiteIDs.push(siteID);
        }
      }

      const selectedChannelGroups = this.state.channelGroups.filter((cg: IChannelGroup) =>
        this.state.ChannelGroupIDS.includes(cg.ID),
      );

      // filter channel groups by the selected IDS and map
      const selectedChannelGroupIDs = this.state.channelGroups
        .filter((cg: IChannelGroup) => this.state.ChannelGroupIDS.includes(cg.ID))
        .map((cg: IChannelGroup) => cg.ID);

      // Get all channels from selected channel groups
      const selectedChannelGroupSitesIDs = this.state.channelGroups
        .filter((cg: IChannelGroup) => this.state.ChannelGroupIDS.includes(cg.ID))
        .map((cg: IChannelGroup) => cg.ChannelIDs)
        .flatMap((item) => item.split(',').map(Number));

      // Merges selected Site IDs with Site IDs from selected channel groups and deletes duplicated site ids
      allCGAndIndividualSiteIDs = Array.from(
        new Set([...allSiteIDs.map(Number), ...selectedChannelGroupSitesIDs]),
      );

      // iterate over selected channel groups' sites
      for (const channelGroup of selectedChannelGroups) {
        for (const site of channelGroup.Sites) {
          if (!(site.ID in channelGroupSiteIDs)) {
            channelGroupSiteIDs[site.ID] = true;
            allSiteIDs.push(site.ID);
          }
        }
      }

      queryHeaderBidders({
        query: {
          publisher_id: this.props.session.publisher.ID,
          site_ids: allCGAndIndividualSiteIDs.join(','),
          channel_group_ids: selectedChannelGroupIDs.join(','),
        },
      }).then(
        (bidders: IHeaderBidder[]) => {
          let bidderCodesList: IMenuList;
          if (this.state.ReportType === REPORTTYPE_TTD) {
            bidderCodesList = {
              thetradedesk: {
                ID: 'thetradedesk',
                title: 'The Trade Desk',
                selected: true,
                disabled: true,
              },
            };
          } else {
            bidderCodesList = genBiddersMenuList(
              this.state.BidderCodes,
              this.props.session.publisher,
              bidders,
              this.state.ssp,
              hasRoleSuperUser(this.props.user.user),
              true,
            );
          }
          this.setState(
            {
              bidders,
              bidderCodesList,
            },
            this.genBidderList,
          );
        },
        (err) => {
          console.error(err);
          this.setState({
            bidders: [],
            snackbarMessage: 'Unable to retrieve header bidders.',
            snackbarError: true,
          });
        },
      );
    };

    getCampaigns = () => {
      this.setState({
        loadingCampaigns: true,
      });
      getCampaigns({
        query: {
          publisher_id: this.props.session.publisher.ID,
          start_date: formatDateStartDay(this.state.dateStart),
          end_date: formatDateEndDay(this.state.dateEnd),
          timezone: this.state.Timezone,
        },
      }).then(
        (campaigns: IAdserverCampaign[]) => {
          this.setState({
            campaigns,
            campaignsList: this.generateCampaignsMenuList(campaigns),
            loadingCampaigns: false,
          });
        },
        () => {
          this.setState({
            campaigns: [],
            loadingCampaigns: false,
            snackbarMessage: 'Unable to retrieve line items.',
            snackbarError: true,
          });
        },
      );
    };

    getOrders = () => {
      this.setState({
        loadingOrders: true,
      });

      getAdserverOrders(this.props.session.publisher.ID, true).then(
        (orders: IAdserverOrder[]) => {
          this.setState({
            orders,
            ordersList: this.generateOrdersMenuList(orders),
            loadingOrders: false,
          });
        },
        () => {
          this.setState({
            orders: [],
            loadingOrders: false,
            snackbarMessage: 'Unable to retrieve campaign orders.',
            snackbarError: true,
          });
        },
      );
    };

    handleGetUniqueOrderAliases = (): void => {
      this.setState({
        loadingOrderAliases: true,
      });
      getUniqueOrderAliases(this.props.session.publisher.ID).then(
        (aliases: IAdserverAlias[]) => {
          this.setState({
            orderAliasesList: this.generateOrderAliasesMenuList(aliases),
            loadingOrderAliases: false,
          });
        },
        () => {
          this.setState({
            loadingOrderAliases: false,
            snackbarMessage: 'Unable to retrieve order aliases.',
            snackbarError: true,
          });
        },
      );
    };

    handleGetUniqueLineItemAliases = (): void => {
      this.setState({
        loadingLineItemAliases: true,
      });
      getUniqueLineItemAliases(this.props.session.publisher.ID).then(
        (aliases: IAdserverAlias[]) => {
          this.setState({
            lineItemAliasesList: this.generateLineItemAliasesMenuList(aliases),
            loadingLineItemAliases: false,
          });
        },
        () => {
          this.setState({
            loadingLineItemAliases: false,
            snackbarMessage: 'Unable to retrieve line item aliases.',
            snackbarError: true,
          });
        },
      );
    };

    getNetworks = () => {
      this.setState({
        loadingNetworks: true,
      });

      getNetworks(this.props.session.publisher.ID)
        .then((val: IHttpResponse<INetwork[]>) => {
          // transform networks
          const networks = [] as INetwork[];
          if (val.parsedBody) {
            for (const item of val.parsedBody) {
              const network = transformNetworkWrapper(item);
              networks.push(network);
            }
          }
          this.setState({
            networks: networks || [],
            networksList: this.generateNetworksMenuList(networks),
            loadingNetworks: false,
          });
        })
        .catch(() => {
          this.setState({
            networks: [],
            loadingNetworks: false,
            snackbarMessage: 'Unable to retrieve networks.',
            snackbarError: true,
          });
        });
    };

    getInventoryRoutesAndDestinations = () => {
      getInventoryRoutesByPublisherID(this.props.session.publisher.ID).then((inventoryRoutes) => {
        const destinations = [] as IDestination[];
        for (const inventoryRoute of inventoryRoutes) {
          destinations.push(...inventoryRoute.Destinations);
        }

        this.setState({
          destinationList: generateDestinationMenuList(
            destinations,
            this.state.DestinationIDs,
            false,
            this.props.user.user.Username,
          ),
          inventoryRouteList: generateInventoryRouteMenuList(
            inventoryRoutes,
            this.state.InventoryRouteIDs,
            this.props.user.user.Username,
          ),
        });
      });
    };

    getAudienceSegments = () => {
      getAudienceSegments({
        query: {
          publisher_id: this.props.session.publisher.ID,
        },
      }).then(
        (segments: IAudienceSegment[]) => {
          this.setState({
            segments,
          });
        },
        () => {
          this.setState({
            segments: [],
            snackbarMessage: 'Unable to retrieve segments.',
            snackbarError: true,
          });
        },
      );
    };

    getCurrencyDisplayed = (): ECurrencyType => {
      if (this.state.CurrencyDisplayed === undefined) {
        return this.props.session.publisher.CurrencyDisplayed;
      }
      return this.state.CurrencyDisplayed;
    };

    getCountryGroups = () => {
      getCountryGroupsByPublisherID(this.props.session.publisher.ID).then(
        (countryGroups: ICountryGroup[]) => {
          this.setState({
            countryGroupsList: generateCountryGroupMenuList(
              countryGroups,
              this.state.ReportFilterConfig.CountryGroupIDs,
            ),
          });
        },
        () => {
          this.setState({
            snackbarMessage: 'Unable to retrieve country groups.',
            snackbarError: true,
          });
        },
      );
    };

    cleanReportStateByReportType = (currReportType: string) => {
      const filterAdvertiserIDs = reportsWithAdvertiserIDFilter;
      const filterBidderIDs = reportsWithBidderIDFilter;
      const filterBidderCodes = reportsWithDemandSourceFilter;
      const filterBidderTier = reportsWithBidderTierFilter;
      const filterChannelGroupIDS = [
        REPORTTYPE_STREAM,
        REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS_SUPER,
      ];
      const filterCountries = reportsWithCountryFilter;
      const filterCountryGroups = reportsWithCountryGroupFilter;
      const filterChannelLabels = reportsWithChannelLabelFilter;
      const filterDeviceTypes = [
        REPORTTYPE_STREAM,
        REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
        REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS_SUPER,
      ];
      const filterDeviceSubtypes = [
        REPORTTYPE_HEADERBIDDER_BYBUYERS,
        REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
        REPORTTYPE_HEADERBIDDER_CAMPAIGN,
        REPORTTYPE_HEADERBIDDER_DESTINATIONS,
        REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
      ];
      const filterDeviceEnvs = [
        REPORTTYPE_HEADERBIDDER_BYBUYERS,
        REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
      ];
      const filterSegmentIDs = [
        REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS,
        REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT,
      ];
      const filterSiteIDs = [
        REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS_SUPER,
        REPORTTYPE_STREAM,
        REPORTTYPE_SHARE_OF_VOICE,
      ];
      const filterAdomains = [REPORTTYPE_HEADERBIDDER_BYBUYERS, REPORTTYPE_HEADERBIDDER_BYAUCTIONS];
      const filterDealIDs = [REPORTTYPE_HEADERBIDDER_BYBUYERS];
      const filterLivestream = [
        REPORTTYPE_HEADERBIDDER_BYBUYERS,
        REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
        REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
        REPORTTYPE_HEADERBIDDER_DESTINATIONS,
      ];
      const filterInventoryRouteIDs = [
        REPORTTYPE_HEADERBIDDER_INVENTORY_ROUTES,
        REPORTTYPE_HEADERBIDDER_DESTINATIONS,
        REPORTTYPE_HEADERBIDDER_BYBUYERS,
        REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
        REPORTTYPE_FAST_AUCTION,
        REPORTTYPE_FAST_BIDDER,
      ];
      const filterOrderAliases = reportsWithOrderAliasesFilter;
      const filterLineItemAliases = reportsWithLineItemAliasesFilter;
      const filterIsPartialAdBreak = [REPORTTYPE_STREAM];
      const filteredState = update(this.state, {
        $merge: {
          StartDate: formatDateWithOffsetToUTC(this.state.dateStart, this.state.Timezone),
          EndDate: formatDateWithOffsetToUTC(this.state.dateEnd, this.state.Timezone),
          Adomains: filterAdomains.includes(currReportType) ? this.state.Adomains : '',
          BidderTierFilter: filterBidderTier.includes(currReportType)
            ? this.state.BidderTierFilter
            : '',
          BidderCodes: filterBidderCodes.includes(currReportType) ? this.state.BidderCodes : [],
          BidderGroupsIDs: filterBidderIDs.includes(currReportType)
            ? this.state.BidderGroupsIDs
            : [],
          BidderIDs: filterBidderIDs.includes(currReportType) ? this.state.BidderIDs : [],
          CampaignIDs:
            currReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN ? this.state.CampaignIDs : [],
          ChannelGroupIDS: !filterChannelGroupIDS.includes(currReportType)
            ? this.state.ChannelGroupIDS
            : [],
          CurrencyDisplayed: this.getCurrencyDisplayed(),
          Countries: filterCountries.includes(currReportType) ? this.state.Countries : [],
          DealIDs: filterDealIDs.includes(currReportType) ? this.state.DealIDs : '',
          DestinationIDs: filterInventoryRouteIDs.includes(currReportType)
            ? this.state.DestinationIDs
            : [],
          DeviceTypes: !filterDeviceTypes.includes(currReportType) ? this.state.DeviceTypes : [],
          DeviceSubtypes: filterDeviceSubtypes.includes(currReportType)
            ? this.state.DeviceSubtypes
            : [],
          DeviceEnvs: filterDeviceEnvs.includes(currReportType) ? this.state.DeviceEnvs : [],
          DMAs:
            currReportType === REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT ? this.state.DMAs : '',
          InventoryRouteIDs: filterInventoryRouteIDs.includes(currReportType)
            ? this.state.InventoryRouteIDs
            : [],
          NetworkIDs:
            currReportType === REPORTTYPE_STREAM ||
            currReportType === REPORTTYPE_STREAM_USER_ACTIVITY
              ? this.state.NetworkIDs
              : [],
          SegmentIDs: filterSegmentIDs.includes(currReportType) ? this.state.SegmentIDs : [],
          SiteIDs: !filterSiteIDs.includes(currReportType) ? this.state.SiteIDs : [],
          States: reportsWithStateFilter.includes(currReportType) ? this.state.States : [],
          StreamTypes:
            currReportType === REPORTTYPE_STREAM ||
            currReportType === REPORTTYPE_STREAM_USER_ACTIVITY
              ? this.state.StreamTypes
              : [],
          IsSiteIDsIncluded: !filterSiteIDs.includes(currReportType)
            ? this.state.IsSiteIDsIncluded
            : 2,
          IsBidderIDsIncluded: filterBidderIDs.includes(currReportType)
            ? this.state.IsBidderIDsIncluded
            : 2,
          OrderAliases: filterOrderAliases.includes(currReportType) ? this.state.OrderAliases : [],
          LineItemAliases: filterLineItemAliases.includes(currReportType)
            ? this.state.LineItemAliases
            : [],
          IsPartialAdBreak: filterIsPartialAdBreak.includes(currReportType)
            ? this.state.IsPartialAdBreak
            : '',
          // filters that do not impact the graph query, but impact queries from db
          ReportFilterConfig: {
            BidderActiveOnly: filterBidderIDs.includes(currReportType)
              ? this.state.ReportFilterConfig.BidderActiveOnly
              : false, // filters for active bidders when true
            ChannelActiveOnly: !filterSiteIDs.includes(currReportType)
              ? this.state.ReportFilterConfig.ChannelActiveOnly
              : false, // filters for active sites when true
            Livestream: filterLivestream.includes(currReportType)
              ? this.state.ReportFilterConfig.Livestream
              : undefined,
            CountryGroupIDs: filterCountryGroups.includes(currReportType)
              ? this.state.ReportFilterConfig.CountryGroupIDs
              : [],
            ChannelLabelIDs: filterChannelLabels.includes(currReportType)
              ? this.state.ReportFilterConfig.ChannelLabelIDs
              : [],
            BidderLabelIDs:
              currReportType === REPORTTYPE_HEADERBIDDER_BYBUYERS
                ? this.state.ReportFilterConfig.BidderLabelIDs
                : [],
            OrderIDs:
              currReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN
                ? this.state.ReportFilterConfig.OrderIDs
                : [],
            AdvertiserIDs: filterAdvertiserIDs.includes(currReportType)
              ? this.state.ReportFilterConfig.AdvertiserIDs
              : [],
          },
        },
      });
      return filteredState;
    };

    generateReportParams = (includeQuotes: boolean, isIASDownloadReport: boolean) => {
      const filteredState = this.cleanReportStateByReportType(this.state.ReportType);
      let report_type = '';
      for (const item of Object.values(this.state.reportTypesList)) {
        if (item.selected) {
          report_type = item.title;
          break;
        }
      }
      const IASAnID = Number(this.state.IASAnID)
        ? Number(this.state.IASAnID)
        : this.props.session.publisher.IASAnID;
      return generateReportParams(filteredState, {
        graph_id: this.getReportGraphID(),
        publisher_id: this.props.session.publisher.ID,
        start_date: formatDateStartDay(this.state.dateStart),
        end_date: formatDateEndDay(this.state.dateEnd),
        timezone: this.state.Timezone,
        currency: this.getCurrencyDisplayed(),
        exchangerate:
          this.state.ExchangeRate !== undefined &&
          this.state.ExchangeRate.ExchangeValueToUSD !== undefined
            ? this.state.ExchangeRate.ExchangeValueToUSD
            : this.props.session.publisher.ExchangeRate.ExchangeValueToUSD,
        report_type: this.state.ReportType,
        includeQuotes,
        report_duration_days: this.state.dateEnd.diff(this.state.dateStart, 'days'),
        report_type_string: report_type,
        ias_body: isIASDownloadReport
          ? this._generateIASQuery(true)
          : ({} as IIASFirstAndThirdPartyRequestBody),
        an_id: IASAnID,
      });
    };

    openReport = ({ snowflakeDebug, previewBeta = false }: Record<string, boolean>) => {
      // validateForm updates the snackbar state if it returns false
      if (!this.validateForm(ReportRetrieveMethodPreview, 'Request to preview report')) {
        return;
      }
      const eventUUID = this.trackEvent('Report - Preview Report');
      window.open(
        genReportURL(
          this.generateReportParams(true, false),
          eventUUID,
          snowflakeDebug,
          previewBeta,
        ),
        '_blank',
      );
    };

    updateReportTypeAndLists = () => {
      // if an existing report is open, preselect the current report type in the report type dropdown
      const reportTypesList = cloneDeep(this.state.reportTypesList);
      Object.values(reportTypesList).forEach((reportType: IListItem) => {
        // for each report type in report type dropdown list
        if (reportType.ID === this.state.ReportType) {
          // if this report type is the one edited, select it per default
          reportType.selected = true;
        }
      });

      // Sets countries for existing report
      const countriesList = selectCountries(this.state.countriesList, this.state.Countries);

      // populate the states list for state filtering dropdown menu
      let statesList = cloneDeep(this.state.statesList);
      if (REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT === this.state.ReportType) {
        usStates.forEach((state: ICountryState) => {
          statesList[state.key] = {
            title: state.name,
            selected: this.state.States.includes(state.key), // for existing report, select state if filtered
            ID: state.key,
          };
        });
      } else if (
        reportsWithStateFilter.includes(this.state.ReportType) &&
        this.state.Countries.length === 1
      ) {
        statesList = generateStatesMenuList(this.state.Countries[0], this.state.States);
      }

      const streamTypesList = cloneDeep(this.state.streamTypesList);
      streamTypes.forEach((streamType: IStreamType) => {
        streamTypesList[streamType.key] = {
          title: streamType.name,
          selected: this.state.StreamTypes.includes(streamType.key),
          ID: streamType.key,
        };
      });

      this.setState({
        reportTypesList,
        countriesList,
        statesList,
        streamTypesList,
      });
    };

    specialMetricsUpdates = (metrics: string[]): string[] => {
      // these groupBys and metrics are pre-determined for Bid Saver True Lift report
      if (this.state.ReportType === REPORTTYPE_BID_SAVER_TRUE_LIFT) {
        // conditional to always group by date and time for the auction fill rate report
        if (!metrics.includes('bid_saver_true_lift')) {
          metrics.push('bid_saver_true_lift');
        }
      }

      return metrics;
    };

    updateSelectedGroupBys = (metrics: string[]) => {
      let GroupByOptions = this.state.GroupByOptions;
      if (this.state.ReportType === REPORTTYPE_STREAM_USER_ACTIVITY) {
        if (metrics.length > 1 || !metrics.includes('sessions_per_user')) {
          GroupByOptions = GroupByOptions.filter((option) => option !== 'num_of_users');
        }
      }
      this.setState({
        GroupByOptions,
      });
    };

    // update the available groupby for selected report
    updateAvailableGroupBysAndMetrics = () => {
      let availableGroupBys: ISQLOption[] = getGroupColumnsByReportID(
        this.state.ReportType,
        this.props.session.publisher.ID,
      ).map(toSQLOption);
      if (this.state.isPresetAggregateSelected) {
        // if a preset aggregate is selected, keep only compatible group bys
        availableGroupBys = this.keepOnlyAggregateCompatibleGroupBys(availableGroupBys);
      }

      const availableMetrics = this.getMetricsList();
      const availableMetricsKeys = availableMetrics.map((metricObj: ISQLOption) => metricObj.key);
      const availableGroupByKeys = availableGroupBys.map(
        (groupByObj: ISQLOption) => groupByObj.key,
      );

      // filter out group by and metric options selected under prev report type that are not in current type
      const GroupByOptions = this.state.GroupByOptions.filter((option: string) =>
        availableGroupByKeys.includes(option),
      );
      const Metrics = this.state.Metrics.filter((metric: string) =>
        availableMetricsKeys.includes(metric),
      );

      // conditional to always group by date and time for the auction fill rate report
      if (this.state.ReportType === REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE) {
        if (!GroupByOptions.includes('impressed_bidder_type')) {
          GroupByOptions.push('impressed_bidder_type');
        }
      }

      // conditional to always group by brand_safety_tracker name and type for for the brand safety tracker report
      if (this.state.ReportType === REPORTTYPE_HEADERBIDDER_BRAND_SAFETY_TRACKER) {
        if (!GroupByOptions.includes('brand_safety_tracker_name')) {
          GroupByOptions.push('brand_safety_tracker_name');
        }
        if (!GroupByOptions.includes('brand_safety_tracker_type')) {
          GroupByOptions.push('brand_safety_tracker_type');
        }
      }

      // conditional to ensure that deal aggregates are always grouped by either inbound deal id, inbound wseat, or bid deal id (defaults to bid deal id)
      if (this.state.ReportType === REPORTTYPE_HEADERBIDDER_DEALS) {
        const hasValidGroupBy =
          GroupByOptions.includes('inbound_deal_id') || GroupByOptions.includes('inbound_wseat');
        if (!hasValidGroupBy) {
          GroupByOptions.push('inbound_deal_id');
        }
      }

      if (this.state.ReportType === REPORTTYPE_BID_FLOOR_SETTINGS_REPORT) {
        // force set all the groupBys to selected because they are all required
        if (!GroupByOptions.includes('biddername')) {
          GroupByOptions.push('biddername');
        }
        if (!GroupByOptions.includes('bidder_id')) {
          GroupByOptions.push('bidder_id');
        }
      }

      if (availableMetrics.length === 1) {
        // auto-select the metric if there is only one available
        this.setState({
          Metrics: [availableMetrics[0].key],
          GroupByOptions,
          availableGroupBys,
        });
      } else {
        this.setState({
          Metrics,
          GroupByOptions,
          availableGroupBys,
        });
      }
    };

    forceUpdateTimezone = (timezone: string) => {
      const clonedList = cloneDeep(this.state.timezonesList);
      if (!clonedList[this.state.Timezone] || !clonedList[timezone]) {
        return;
      }
      clonedList[this.state.Timezone].selected = false;
      clonedList[timezone].selected = true;
      this.setState({
        timezonesList: clonedList,
        Timezone: timezone,
      });
    };

    // keep only group bys compatible with the preset aggregates request
    keepOnlyAggregateCompatibleGroupBys = (groupBys: ISQLOption[]) => {
      // create a new array with only compatible elements
      const compatibleGroupBys: ISQLOption[] = [];
      groupBys.forEach((groupBy: ISQLOption) => {
        // for each groupby in input list
        if (!groupBy.key.match(/^(day|hour|month|week_of_year)/i)) {
          // time range group by are incompatible with aggregates
          // this groupby is compatible with aggregates, add it
          compatibleGroupBys.push(groupBy);
        }
      });
      return compatibleGroupBys;
    };

    snackbarClose = () => {
      this.setState({
        snackbarMessage: '',
        snackbarError: false,
      });
    };

    gotoReportListView = () => {
      navigate(
        RouteBidderReportsList,
        extractRouteParams({
          session: this.props.session,
          user: this.props.user,
        }),
      );
    };

    extraValidations = (errors: IErrors, method: ReportRetrieveMethod): IErrors => {
      if (this.state.Frequency === '1' && this.state.Period === '7') {
        errors.Frequency = 'Cannot schedule year-to-date report on a daily interval';
        errors.Period = 'Cannot schedule year-to-date report on a daily interval';
      }
      if (this.state.ReportType === REPORTTYPE_IAS_FIRST_PARTY) {
        const AnID = Number(this.state.IASAnID)
          ? Number(this.state.IASAnID)
          : this.props.session.publisher.IASAnID;
        if (!AnID) {
          errors.IASAnID = 'Please get assigned an AnID before querying 1st party data';
        }
      }
      if (
        method === ReportRetrieveMethodSchedule &&
        EBool.isTrue(this.state.ShouldUploadToExternalS3) &&
        Object.keys(this.state.s3AccessPoint).length === 0
      ) {
        errors.S3AccessPoint = 'Publisher settings missing S3 access point credentials';
      }
      if (
        ![ReportRetrieveMethodEmail, ReportRetrieveMethodUnknown].includes(method) &&
        this.state.Adomains !== ''
      ) {
        const limit = parseInt(this.state.ReportLimit, 10) || 0;
        if (isNaN(limit) || limit <= 0 || limit > 500000) {
          errors.ReportLimit = 'Adomain filter requires a Limit between 1 and 500000.';
        }
      }
      // creative validation report requires <= 7 day period and at least one venue id filter (for pub 408)
      if (this.state.ReportType === REPORTTYPE_CREATIVE_VALIDATION) {
        if (this.state.VenueIDs === '' && this.props.session.publisher.ID === '408') {
          errors.VenueIDs = 'At least one venue ID is required';
        }
        const diff = this.state.dateEnd.diff(this.state.dateStart, 'days');
        if (diff > 7 && this.state.ReportType !== REPORTTYPE_TTD) {
          errors.DateRange = 'Date range may not be greater than 7 days for this report';
        }
      }

      return errors;
    };

    validateForm = (method: ReportRetrieveMethod, actionText?: string): boolean => {
      const errors = validate(this.state); // todo need to allow bid_floor to not have any metrics
      if (hasErrors(errors)) {
        this.setState({
          errors,
          snackbarMessage: `Save failed. ${Object.values(errors)
            .filter((err) => err !== '')
            .join('. ')}`,
          snackbarError: true,
        });
        return false;
      }

      const allErrors = this.extraValidations(errors, method);

      const errDedup = new Set();
      for (const err of Object.values(allErrors)) {
        errDedup.add(err);
      }

      if (hasErrors(allErrors)) {
        if (!actionText) {
          this.setState({
            errors: allErrors,
          });
          return false;
        } else {
          this.setState({
            errors: allErrors,
            snackbarMessage: `${actionText} failed. ${Array.from(errDedup)
              .filter((err) => err !== '')
              .join('. ')}`,
            snackbarError: true,
          });
          return false;
        }
      }
      this.setState({
        errors: {} as IErrors,
      });
      return true;
    };

    saveReport = (fromScheduled: boolean = false) => {
      if (
        fromScheduled &&
        this.state.Recipients.length <= 0 &&
        this.state.ShouldUploadToExternalS3 === EBool.EBool_FALSE
      ) {
        this.setState({
          snackbarMessage: "Can't save report as recipient(s) are empty.",
          snackbarError: true,
        });
        return;
      }
      const ReportFilterConfigLength = JSON.stringify(this.state.ReportFilterConfig).length;
      if (ReportFilterConfigLength > 65535) {
        this.setState({
          snackbarMessage: `Can't save report. Please shorten filtering options. \n Filter options cannot exceed 65535 characters. Current character count: ${ReportFilterConfigLength}`,
          snackbarError: true,
        });
        return;
      }
      const countUpdating = this.state.countUpdating + 1;
      this.setState({
        updating: true,
        countUpdating,
      });
      this._saveReport(countUpdating, fromScheduled);
    };

    warnBeforeSendEmail = () => {
      this.setState({
        isSendNowWarningOpen: true,
      });
    };

    onCloseSendEmailWarning = (canContinue: boolean) => {
      this.setState(
        {
          isSendNowWarningOpen: false,
        },
        () => {
          if (canContinue) {
            this.sendEmail(false, false);
          }
        },
      );
    };

    // useStartEndDate signifies the Send Email Button up top is used instead of the bottom
    // this uses the start and end date selectors instead of the "period" and sends the report to the user
    // not the listed recipients in the Schedule section
    sendEmail = (useStartEndDate: boolean, isEmailToSelf: boolean) => {
      if (
        this.state.Recipients.length <= 0 &&
        !useStartEndDate &&
        this.state.ShouldUploadToExternalS3 === EBool.EBool_FALSE
      ) {
        this.setState({
          snackbarMessage: "Can't send report as recipient(s) are empty.",
          snackbarError: true,
        });
        return;
      }
      const countSending = this.state.countSending + 1;
      this.setState({
        sending: true,
        countSending,
      });
      this._sendEmail(countSending, useStartEndDate, isEmailToSelf);
    };

    // Sends report as if it were scheduled to be sent right now
    scheduleReport = () => {
      const countSending = this.state.countSending + 1;
      this.setState({
        sending: true,
        countSending,
      });
      this._scheduleReport(countSending);
    };

    handleChannelAcceptClick = (channelList: IMenuList): void => {
      const SiteIDs: string[] = [];
      Object.values(channelList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          SiteIDs.push(listItem.ID);
        }
      });
      this.setState(
        {
          channelList,
          SiteIDs,
        },
        this.getHeaderBidders,
      );
    };

    handleChannelGroupsAcceptClick = (): void => {
      const ChannelGroupIDS: number[] = [];
      Object.values(this.state.channelGroupsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelGroupIDS.push(parseInt(listItem.ID, 10));
        }
      });
      this.setState(
        {
          ChannelGroupIDS,
        },
        this.getHeaderBidders,
      );
    };

    handleDestinationsAcceptClick = (): void => {
      const DestinationIDs: string[] = [];
      Object.values(this.state.destinationList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          DestinationIDs.push(listItem.ID.toString());
        }
      });
      this.setState({
        DestinationIDs,
      });
    };

    handleInventoryRoutesAcceptClick = (): void => {
      const InventoryRouteIDs: string[] = [];
      Object.values(this.state.inventoryRouteList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          InventoryRouteIDs.push(listItem.ID.toString());
        }
      });
      this.setState({
        InventoryRouteIDs,
      });
    };

    handleTimezoneAcceptClick = (values: IMenuList): void => {
      for (const { title, selected } of Object.values(values)) {
        if (selected) {
          this.setState(
            {
              Timezone: title,
            },
            this.getCampaigns,
          );
          break;
        }
      }
    };

    handleCurrencyAcceptClick = (values: IMenuList): void => {
      for (const { defaultWeight, selected } of Object.values(values)) {
        if (selected && defaultWeight !== undefined) {
          this.setState({
            CurrencyDisplayed: defaultWeight,
          });
          getExchangeRate(defaultWeight).then((exchange: IExchangeRate) => {
            this.setState({
              ExchangeRate: exchange || this.props.report.ExchangeRate,
            });
          });
          break;
        }
      }
    };

    // get the metrics list for the current report
    getMetricsList = (): ISQLOption[] => {
      const { Adomains, fwPublisherIDs, GroupByOptions, ReportType } = this.state;
      const metricsRes = getMetricColumnsByReportID(
        ReportType,
        this.props.session.publisher.ID,
        fwPublisherIDs,
        GroupByOptions || [],
        this.props.user.user,
        isCreativeTagEventsEnabled(this.props.session.publisher),
      );
      let metrics = metricsRes.map(toSQLOption);

      // If the user isn't a super user, remove any super user only metrics
      if (!hasRoleSuperUser(this.props.user.user)) {
        metrics = metrics.filter(
          (metric: ISQLOption) => !superUserOnlyMetrics.includes(metric.key),
        );
      }

      // only the metrics available in `adomainFilterMetrics` should be shown when
      // there is text in the adomain filter
      if (Adomains && Adomains.length > 0) {
        metrics = metrics.filter((metric: ISQLOption) => adomainFilterMetrics.includes(metric.key));
      }

      return metrics;
    };

    handleBidderAcceptClick = (): void => {
      const BidderIDs: string[] = [];
      Object.values(this.state.bidderList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          BidderIDs.push(listItem.ID);
        }
      });
      this.setState({
        BidderIDs,
      });
    };

    handleBidderGroupsAcceptClick = (): void => {
      const BidderGroupsIDs: string[] = [];
      Object.values(this.state.bidderGroupsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          BidderGroupsIDs.push(listItem.ID);
        }
      });
      this.setState({
        BidderGroupsIDs,
      });
    };

    handleCountryAcceptClick = (): void => {
      const CountryIDs: string[] = [];
      Object.values(this.state.countriesList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          CountryIDs.push(listItem.ID);
        }
      });

      let newStatesList;
      // we want to clear any selected states if the country selection are changed
      if (
        JSON.stringify(this.state.Countries) !== JSON.stringify(CountryIDs) &&
        CountryIDs.length === 1
      ) {
        newStatesList = generateStatesMenuList(CountryIDs[0], []);
      } else if (CountryIDs.length !== 1) {
        newStatesList = {};
      } else {
        newStatesList = this.state.statesList;
      }

      this.setState({
        Countries: CountryIDs,
        statesList: newStatesList,
        States:
          JSON.stringify(this.state.Countries) !== JSON.stringify(CountryIDs)
            ? []
            : this.state.States,
      });
    };

    handleCountryGroupAcceptClick = (): void => {
      const CountryGroupIDs: string[] = [];
      Object.values(this.state.countryGroupsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          CountryGroupIDs.push(listItem.ID);
        }
      });
      const ReportFilterConfig: IReportFilterConfig = {
        ...this.state.ReportFilterConfig,
        CountryGroupIDs,
      };
      this.setState({
        ReportFilterConfig,
      });
    };

    handleChannelLabelAcceptClick = (): void => {
      const ChannelLabelIDs: string[] = [];
      Object.values(this.state.channelLabelsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          ChannelLabelIDs.push(listItem.ID);
        }
      });
      const ReportFilterConfig: IReportFilterConfig = {
        ...this.state.ReportFilterConfig,
        ChannelLabelIDs,
      };
      this.setState({
        ReportFilterConfig,
      });
    };

    handleBidderLabelAcceptClick = (): void => {
      const BidderLabelIDs: string[] = [];
      Object.values(this.state.bidderLabelsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          BidderLabelIDs.push(listItem.ID);
        }
      });
      const ReportFilterConfig: IReportFilterConfig = {
        ...this.state.ReportFilterConfig,
        BidderLabelIDs,
      };
      this.setState({
        ReportFilterConfig,
      });
    };

    handleStatesAcceptClick = (): void => {
      const StateIDs: string[] = [];
      Object.values(this.state.statesList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          StateIDs.push(listItem.ID);
        }
      });
      this.setState({
        States: StateIDs,
      });
    };

    handleCampaignAcceptClick = (): void => {
      const CampaignIDs: string[] = [];
      Object.values(this.state.campaignsList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          CampaignIDs.push(listItem.ID);
        }
      });
      this.setState({
        CampaignIDs,
      });
    };

    handleLineItemAliasAcceptClick = (): void => {
      const LineItemAliases: string[] = [];
      Object.values(this.state.lineItemAliasesList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          LineItemAliases.push(listItem.title);
        }
      });
      this.setState({
        LineItemAliases,
      });
    };

    handleOrderAcceptClick = (): void => {
      const OrderIDs: string[] = [];
      Object.values(this.state.ordersList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          OrderIDs.push(listItem.ID);
        }
      });
      const ReportFilterConfig: IReportFilterConfig = {
        ...this.state.ReportFilterConfig,
        OrderIDs,
      };
      this.setState({
        ReportFilterConfig,
      });
    };

    handleOrderAliasAcceptClick = (): void => {
      const OrderAliases: string[] = [];
      Object.values(this.state.orderAliasesList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          OrderAliases.push(listItem.title);
        }
      });
      this.setState({
        OrderAliases,
      });
    };

    handleBidderTierAcceptClick = (): void => {
      this.setState({
        BidderTierFilter: Object.values(this.state.bidderTierFilterList)
          .filter((listItem: IListItem) => {
            return listItem.selected;
          })
          .map((listItem: IListItem) => {
            return listItem.ID;
          })
          .join(','),
      });
    };

    handleReportFilterConfigTrueFalseClick = (): void => {
      let IsPartialAdBreak: string = '';
      if (
        this.state.IsPartialAdBreakList.False?.selected &&
        this.state.IsPartialAdBreakList.True?.selected
      ) {
        this.setState({
          IsPartialAdBreak,
        });
        return;
      }
      if (this.state.IsPartialAdBreakList.True?.selected) {
        IsPartialAdBreak = 'true';
      } else if (this.state.IsPartialAdBreakList.False?.selected) {
        IsPartialAdBreak = 'false';
      }
      this.setState({
        IsPartialAdBreak,
      });
    };

    handleNetworkAcceptClick = (): void => {
      const NetworkIDs: string[] = [];
      Object.values(this.state.networksList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          NetworkIDs.push(listItem.ID);
        }
      });
      this.setState({
        NetworkIDs,
      });
    };

    handleBidderCodeAcceptClick = (): void => {
      const BidderCodeIDs: string[] = [];
      Object.values(this.state.bidderCodesList).forEach((listItem: IListItem) => {
        if (listItem.selected) {
          BidderCodeIDs.push(listItem.ID);
        }
      });
      this.setState({
        BidderCodes: BidderCodeIDs,
      });
    };

    setStateCallback = (keys: string[], values: any[], setStateCallbacks: Array<() => void>) => {
      const stateObj = {} as IState;
      for (let i = 0; i < keys.length; i++) {
        stateObj[keys[i]] = values[i];
      }
      this.setState(stateObj, () => {
        setStateCallbacks.forEach((callback: () => void) => callback());
      });
    };

    getReportGraphID = (): string => {
      const { GroupByOptions, Metrics, ReportType } = this.state;
      const filteredState = this.cleanReportStateByReportType(this.state.ReportType);
      return getReportGraphID(ReportType, GroupByOptions, Metrics, filteredState);
    };

    getToolTipMsg = (isExtended: boolean, checkPeriod: boolean): string => {
      if (this.hasBlockedGroupByForPreview()) {
        return GROUP_BY_NOT_ALLOWED_FOR_PREVIEW;
      } else if (!this.state.Metrics.length || !this.state.GroupByOptions.length) {
        return SELECT_GROUP_BY_AND_METRIC;
      } else if (checkPeriod && !this.isPeriodAllowed()) {
        return PERIOD_NOT_ALLOWED;
      } else if (!checkPeriod && !this.isDateRangeAllowed()) {
        return DATE_RANGE_NOT_ALLOWED;
      } else if (isExtended) {
        return PLEASE_USE_EMAIL;
      } else {
        return '';
      }
    };

    isDateRangeAllowed = (): boolean => {
      // Tier 1 publishers won't have a restriction
      if (this.props.session.publisher.RateLimitTier === 1) {
        return true;
      }

      // Check to see if date range is too large
      if (this.state.dateEnd.diff(this.state.dateStart, 'day') > 90) {
        return false;
      }

      return true;
    };

    hasBlockedGroupByForPreview = (): boolean => {
      const blockedGroupBys = ['recognition_result_enriched_language_input'];
      for (const blockedGroupBy of blockedGroupBys) {
        if (this.state.GroupByOptions.includes(blockedGroupBy)) {
          return true;
        }
      }
      return false;
    };

    isPeriodAllowed = (): boolean => {
      // Tier 1 publishers won't have a restriction
      if (this.props.session.publisher.RateLimitTier === 1) {
        return true;
      }

      // Check to see if date range is too large
      if (this.state.Period === '7') {
        return false;
      }

      return true;
    };

    // render the Preview button
    renderPreviewButton = (isExtended: boolean) => {
      const { ReportType, GroupByOptions, Metrics, readAuthorization } = this.state;
      return (
        <Tooltip title={this.getToolTipMsg(isExtended, false)} placement='bottom'>
          <div>
            <ModelPrimaryButton
              variant='contained'
              onClick={() => this.openReport({ snowflakeDebug: false, previewBeta: false })}
              color='primary'
              disabled={
                !readAuthorization.isAuthorized ||
                isExtended ||
                (!reportsWithoutMetrics.includes(ReportType) && isEmpty(Metrics)) ||
                (!reportsWithoutGroupBy.includes(ReportType) && isEmpty(GroupByOptions)) ||
                !this.isDateRangeAllowed() ||
                this.hasBlockedGroupByForPreview() ||
                ReportType === REPORTTYPE_TTD
              }
              style={{
                margin: 8,
              }}
            >
              Preview
            </ModelPrimaryButton>
          </div>
        </Tooltip>
      );
    };

    // render the View Query* button
    renderSnowflakeDebugButton = () => {
      const { ReportType, GroupByOptions, Metrics } = this.state;
      return (
        <div>
          <ModelPrimaryButton
            variant='contained'
            onClick={() => this.openReport({ snowflakeDebug: true, previewBeta: false })}
            color='primary'
            disabled={
              (!reportsWithoutMetrics.includes(ReportType) && isEmpty(Metrics)) ||
              (!reportsWithoutGroupBy.includes(ReportType) && isEmpty(GroupByOptions))
            }
            style={{
              margin: 8,
            }}
          >
            View Query *
          </ModelPrimaryButton>
        </div>
      );
    };

    // render the Preview Beta* button
    renderPreviewBetaButton = () => {
      const { ReportType, GroupByOptions, Metrics } = this.state;
      return (
        <div>
          <ModelPrimaryButton
            variant='contained'
            onClick={() => this.openReport({ snowflakeDebug: false, previewBeta: true })}
            color='primary'
            disabled={
              (!reportsWithoutMetrics.includes(ReportType) && isEmpty(Metrics)) ||
              (!reportsWithoutGroupBy.includes(ReportType) && isEmpty(GroupByOptions))
            }
            style={{
              margin: 8,
            }}
          >
            Preview Beta *
          </ModelPrimaryButton>
        </div>
      );
    };

    // render the save button
    renderSaveButton = () => {
      const { classes } = this.props;
      return (
        <>
          {!this.state.writeAuthorization.isAuthorized ? (
            <Grid item>
              <ChipInactive label='Read-Only' />
            </Grid>
          ) : (
            <Tooltip title={this.getToolTipMsg(false, false)} placement='bottom'>
              <div>
                <ModelSecondaryButton
                  className={classes.button}
                  onClick={() => this.saveReport(false)}
                  disabled={
                    this.state.updating ||
                    !this.state.writeAuthorization.isAuthorized ||
                    !this.state.Metrics.length ||
                    !this.state.GroupByOptions.length
                  }
                >
                  {this.state.updating && <CircularProgress size={12} />}
                  Save
                </ModelSecondaryButton>
              </div>
            </Tooltip>
          )}
        </>
      );
    };

    renderDownloadButton = (isExtended: boolean) => {
      const { classes } = this.props;
      return (
        <Tooltip title={this.getToolTipMsg(isExtended, false)} placement='bottom'>
          <div>
            <ModelSecondaryButton
              className={classes.button}
              // @ts-ignore
              download
              href={
                !!this.state.Metrics.length && !!this.state.GroupByOptions.length
                  ? createDownloadReportURL(
                      this.generateReportParams(false, isIASReport(this.state.ReportType)),
                      isIASReport(this.state.ReportType),
                    )
                  : '#'
              }
              onClick={(e) => {
                // validateForm updates the snackbar state if it returns false
                if (
                  !this.validateForm(ReportRetrieveMethodDownload, 'Request to download report')
                ) {
                  e.preventDefault();
                  return;
                }
                this.trackEvent('Report - Download Report');
              }}
              disabled={
                !this.state.readAuthorization.isAuthorized ||
                isExtended ||
                !this.state.Metrics.length ||
                !this.state.GroupByOptions.length ||
                !this.isDateRangeAllowed()
              }
            >
              Download
            </ModelSecondaryButton>
          </div>
        </Tooltip>
      );
    };

    // render the send email button
    renderSendEmailButton = () => {
      const { classes } = this.props;
      return (
        <Tooltip title={this.getToolTipMsg(false, false)} placement='bottom'>
          <div>
            <ModelSecondaryButton
              className={classes.button}
              onClick={() => this.sendEmail(true, true)}
              disabled={
                !this.state.Metrics.length ||
                !this.state.GroupByOptions.length ||
                !this.isDateRangeAllowed()
              }
            >
              Email
            </ModelSecondaryButton>
          </div>
        </Tooltip>
      );
    };

    // render the main buttons - save, close, preview and download
    renderMainButtons = () => {
      const { classes } = this.props;
      const isExtended = IsExtendedGraph(this.getReportGraphID());
      return (
        <Cols>
          {hasRoleSuperUser(this.props.user.user) && <Col>{this.renderPreviewBetaButton()}</Col>}
          {hasRoleSuperUser(this.props.user.user) && <Col>{this.renderSnowflakeDebugButton()}</Col>}
          <Col>{this.renderPreviewButton(isExtended)}</Col>
          <Col>{this.renderSaveButton()}</Col>
          <Col>{this.renderDownloadButton(isExtended)}</Col>
          <Col>{this.renderSendEmailButton()}</Col>
          <Col>
            <ModelSecondaryButton className={classes.button} onClick={this.gotoReportListView}>
              Close
            </ModelSecondaryButton>
          </Col>
        </Cols>
      );
    };

    // handle the change of report type via the 'Report Type' dropdown
    handleReportTypeChange = (list: IMenuList) => {
      // if we are switching from a TTD report, need to refill the channel list
      if (this.state.ReportType === REPORTTYPE_TTD) {
        this.genChannelList();
      }
      // set the selected value in state.ReportType
      const selected = Object.values(list).filter((entry: IListItem) => entry.selected);
      if (selected.length >= 1) {
        this.setState(
          {
            ReportType: selected[0].ID, // update the current report type
            reportTypesList: list, // update list of report to include the one selected
            errors: {} as IErrors,
          },
          this.afterReportChange,
        );
      }
    };

    // handle actions after the report type has been changed in the state
    afterReportChange = () => {
      // refresh the list of group bys and metrics available for the current report
      this.updateAvailableGroupBysAndMetrics();
      this.refreshS3AccessPoint();
      // If switched to IAS Report, force America/New_York
      if (isIASReport(this.state.ReportType) && this.state.Timezone !== 'America/New_York') {
        this.forceUpdateTimezone('America/New_York');
      }
      if (this.state.ReportType === REPORTTYPE_TTD) {
        this.genBidderList();
        this.filterChannelListForTTD();
        // default select US dollar
        const newCurrencyList = genCurrencyList(0);
        this.setState({
          GroupByOptions: [
            'day',
            'currency_type',
            'timezone',
            'market_type',
            'media_type',
            'publisher_id',
          ],
          Metrics: ['impressions', 'media_cost', 'bid_responses'],
          bidderCodesList: {
            thetradedesk: {
              ID: 'thetradedesk',
              title: 'The Trade Desk',
              selected: true,
              disabled: true,
            },
          },
          timezonesList: {
            UTC: {
              title: 'UTC',
              ID: 'UTC',
              selected: true,
            },
          },
          Timezone: 'UTC',
          dateStart: getStartDate(this.props.report.Timezone || 'UTC', 30, 'day').startOf('day'),
          dateEnd: getEndDate(this.props.report.Timezone || 'UTC').endOf('day'),
          CurrencyDisplayed: 0,
          currencyList: newCurrencyList,
          Period: '8',
        });
      }
    };

    // handle the selection of a preset aggregate
    handlePresetAggregateSelection = (selectedVariables: string[]) => {
      for (let i = 0; i < selectedVariables.length; i++) {
        if (selectedVariables[i].startsWith('preset_aggregate_')) {
          // a preset aggregate is selected
          this.setState(
            {
              isPresetAggregateSelected: true,
            },
            this.updateAvailableGroupBysAndMetrics,
          );
          return;
        }
      }
      // no preset aggregate is selected
      this.setState(
        {
          isPresetAggregateSelected: false,
        },
        this.updateAvailableGroupBysAndMetrics,
      );
    };

    generateCampaignsMenuList = (campaigns: IAdserverCampaign[]): IMenuList => {
      const campaignsAsIMenuList: IMenuList = {};

      campaigns.forEach((campaign: IAdserverCampaign) => {
        const selectedInd: number = this.state.CampaignIDs.findIndex(
          (ID: string) => ID === campaign.ID,
        );
        campaignsAsIMenuList[campaign.ID] = {
          ID: campaign.ID,
          selected: selectedInd !== -1,
          title: obfuscateCampaignName(
            campaign,
            this.props.user.user.Username,
            `${campaign.Name} (${campaign.ID})`,
          ),
        };
      });

      return campaignsAsIMenuList;
    };

    generateOrdersMenuList = (orders: IAdserverOrder[]): IMenuList => {
      const ordersAsIMenuList: IMenuList = {};

      orders.forEach((order: IAdserverOrder) => {
        const orderID = '' + order.ID;
        const selectedInd: number = this.state.ReportFilterConfig.OrderIDs.findIndex(
          (ID: string) => ID === orderID,
        );
        ordersAsIMenuList[orderID] = {
          ID: orderID,
          selected: selectedInd !== -1,
          title: obfuscateOrderName(
            order,
            this.props.user.user.Username,
            `${order.Name} (${orderID})`,
          ),
        };
      });

      return ordersAsIMenuList;
    };

    generateOrderAliasesMenuList = (aliases: IAdserverAlias[]): IMenuList => {
      const orderAliasesAsIMenuList: IMenuList = {};

      aliases.forEach((alias, idx) => {
        orderAliasesAsIMenuList[idx] = {
          ID: idx.toString(),
          selected: this.state.OrderAliases.includes(alias.Name),
          title: alias.Name,
        };
      });

      return orderAliasesAsIMenuList;
    };

    generateLineItemAliasesMenuList = (aliases: IAdserverAlias[]): IMenuList => {
      const lineItemAliasesAsIMenuList: IMenuList = {};

      aliases.forEach((alias, idx) => {
        lineItemAliasesAsIMenuList[idx] = {
          ID: idx.toString(),
          selected: this.state.LineItemAliases.includes(alias.Name),
          title: alias.Name,
        };
      });

      return lineItemAliasesAsIMenuList;
    };

    generateNetworksMenuList = (networks: INetwork[]): IMenuList => {
      const networksAsIMenuList: IMenuList = {};

      networks.forEach((network: INetwork) => {
        const selectedInd: number = this.state.NetworkIDs.findIndex(
          (ID: string) => ID === network.ID.toString(),
        );
        networksAsIMenuList[network.ID] = {
          ID: network.ID.toString(),
          selected: selectedInd !== -1,
          title: network.Name,
        };
      });

      return networksAsIMenuList;
    };

    getSubCategories = () => {
      const { ReportType } = this.state;
      if (
        [REPORTTYPE_IAS_PERFORMANCE, REPORTTYPE_IAS_DEVICE, REPORTTYPE_IAS_YOUTUBE].includes(
          ReportType,
        )
      ) {
        return [
          // IAS Publisher Reports
          {
            title: 'Summary',
            matchRegex:
              'Total Tracked Ads|Rendered Impressions|^Invalid Traffic Ads$|Eligible Ads|Measured Ads|Viewable Impressions|Blocked Ads|Render Rate|^Invalid Traffic Rate$|Measured Rate|Viewability Rate|Blocked Rate',
          },
          { title: 'GroupM Viewability', matchRegex: 'GroupM.*|Total Billable Impressions' },
          {
            title: 'Invalid Traffic',
            matchRegex:
              'Sitting Duck Bot Impressions|Standard Bot Impressions|Volunteer Bot Impressions|Profile Bot Impressions|Masked Bot Impressions|Nomadic Bot Impressions|Other Bot Impressions',
          },
          { title: 'Failure Risk Categories', matchRegex: 'Failed.*Ads' },
          {
            title: 'Ad Refresh',
            matchRegex: 'Refresh Ads|IAS Refreshed Ads|Refreshed Ad Rate|IAS Refreshed Ad Rate',
          },
          {
            title: 'Publicis Viewability',
            matchRegex:
              'Publicis Fully In View Display Impressions|Publicis Fully In View Video Impressions|Publicis Display Viewable Rate|Publicis Video Viewable Rate',
          },
          {
            title: 'Blocked Reasons',
            matchRegex:
              'Blocked by Brand Safety|Blocked by Brand Suitability|Blocked by Custom Keyword Exclusion List|Blocked by Custom URL/App Exclusion List|Blocked by Geo|Blocked by Invalid Traffic|Blocked by Invisible URL|Blocked by Target Language Mismatch',
          },
          { title: 'Exposure', matchRegex: 'In View .*' },
          {
            title: 'Out Of View Ads',
            matchRegex:
              /Not Enough Time|Not Enough Pixels|Never On Screen|Out Of Focus|Video Never Started|Other Out Of View/,
          },
          { title: 'Failure Reasons', matchRegex: 'Failed for .*' },
          { title: 'Blocked Risk Categories', matchRegex: 'Blocked .* Ads' },
          {
            title: 'Video',
            matchRegex:
              '% In View|% Out Of View|% Ad Never Started|% Completed|% Completed In View|% Muted|% Full Screen|% Click Through (CTR)',
          },
          {
            title: 'Invalid Traffic By Type',
            matchRegex:
              /General Invalid Traffic \(GIVT\) Ads|Bots \(SIVT\) Ads|Hidden Ads \(SIVT\)|Domain Spoofing \(SIVT\)|Incentivized Browsing \(RVI\) Ads|Proxy Servers \(RVI\) Ads|Sophisticated Invalid Traffic Ads|Reduced Value Inventory Ads|General Invalid Traffic Rate|Sophisticated Invalid Traffic Rate|Reduced Value Inventory Rate/,
          },
        ];
      }
      return [
        // EleaAI Enrichment
        {
          title: 'Total number of mediafiles by EleaAI',
          matchRegex: /.+\(total mediafiles, EleaAI\)/,
        },
        {
          title: 'Number of unique mediafiles by EleaAI',
          matchRegex: /.+\(unique mediafiles, EleaAI\)/,
        },
        { title: 'Total number of adomains by EleaAI', matchRegex: /.+\(total adomains, EleaAI\)/ },
        {
          title: 'Number of unique adomains by EleaAI',
          matchRegex: /.+\(unique adomains, EleaAI\)/,
        },
        {
          title: 'Total number of detected languages by EleaAI',
          matchRegex: /.+\(total detected languages, EleaAI\)/,
        },
        {
          title: 'Number of unique detected languages by EleaAI',
          matchRegex: /.+\(unique detected languages, EleaAI\)/,
        },
        // EleaAI Scan All
        { title: 'Sum with adomains', matchRegex: /.+\(with adomains, EleaAI\)/ },
        { title: 'Sum with different adomains', matchRegex: /.+\(different adomains, EleaAI\)/ },

        { title: 'Ratios', matchRegex: /.*Rate(?! (Non-)*CST)/ },
        { title: 'Inventory Routes', matchRegex: /(^Inventory .*|.*Destination$)/ },
        {
          title: 'Auctions',
          matchRegex: getResellerTitle() !== 'Publica' ? rokuAuctionRegex : commonAuctionRegex,
        },
        {
          title: 'Revenue',
          matchRegex:
            /(^Average .*|.*Revenue$|.*CPM|Bid Saver Pod Lift|Bid Saver True Lift|Partner Revenue|Partner CPM|Active Margin|Unit Cost)/,
        },
        {
          title: 'Errors',
          matchRegex:
            /(Bid Errors|Bid Timeouts|Rejected Winning Bids|Vast Errors|Prebid Errors|Postbid Errors|Bid Rejections|Duration Exceeded|HLS Reject|Stream Error|Stream Ads Fetch Timeout|Stream Chunklist Timeout|Stream Playlist Timeout)/,
        },
        { title: 'Line Item Metrics', matchRegex: /^Line Item .*/ },
        { title: 'Creative Tag Metrics', matchRegex: /^Creative .*/ },
        { title: 'Latency', matchRegex: '.*Latency' },
        { title: 'Pod Duration', matchRegex: '.*Pod Duration' },
        { title: 'VPAID', matchRegex: /(^VPAID .*)/ },
        { title: 'Average per Session', matchRegex: /^Avg .+ per Session$/ },
        { title: 'Client-Side Tracking', matchRegex: /^CST.*|.*CST$/ },
        { title: 'Others', matchRegex: /./ },
      ];
    };

    clearButtonOnClick = () => {
      if (this.state.ReportFilterConfig.Livestream !== undefined) {
        const cloneReportFilterConfig = cloneDeep(this.state.ReportFilterConfig);
        delete cloneReportFilterConfig.Livestream;
        this.setState({ ReportFilterConfig: cloneReportFilterConfig });
      }
    };

    render() {
      const { classes, user, session, location } = this.props;
      const { pathname } = location;
      const {
        Active,
        Adomains,
        availableGroupBys,
        bidderCodesList,
        bidderGroupsList,
        bidderLabelsList,
        bidderList,
        campaignsList,
        channelGroupsList,
        channelLabelsList,
        channelList,
        countriesList,
        countryGroupsList,
        currencyList,
        ordersList,
        dateEnd,
        dateStart,
        DealIDs,
        destinationList,
        DeviceEnvs,
        DeviceSubtypes,
        DeviceTypes,
        DMAs,
        errors,
        Frequency,
        fwPublisherIDs,
        GroupByOptions,
        IASAnID,
        inventoryRouteList,
        isPresetAggregateSelected,
        isSendNowWarningOpen,
        loadingBidders,
        loadingBidderGroupsAndLabels,
        loadingCampaigns,
        loadingChannels,
        loadingChannelGroupsAndLabels,
        loadingLineItemAliases,
        loadingNetworks,
        loadingOrderAliases,
        loadingOrders,
        Metrics,
        Name,
        networksList,
        lineItemAliasesList,
        orderAliasesList,
        Period,
        quickFilterOptions,
        Recipients,
        ShouldUploadToExternalS3,
        ReportFilterConfig,
        ReportLimit,
        ReportOrderBy,
        ReportType,
        reportTypesList,
        ScheduledDay,
        SegmentIDs,
        segments,
        sending,
        snackbarError,
        snackbarMessage,
        statesList,
        streamTypesList,
        Subject,
        SuperOnly,
        Timezone,
        timezonesList,
        updating,
        VenueIDs,
        writeAuthorization,
      } = this.state;

      const allowDealReportBidderFilters =
        ReportType === REPORTTYPE_HEADERBIDDER_DEALS &&
        !Metrics.includes('endpoint_requests') &&
        !Metrics.includes('endpoint_responses');
      const deviceSubtypes = getDeviceEnvironmentSubTypes(
        this.props.session.publisher.ID,
        hasRoleSuperUser(this.props.user.user),
      );
      return (
        <Panels maxWidth vertical relative minWidthMain>
          <Panel
            largeHorizontalPadding
            verticalPadding
            style={{ borderBottom: `1px solid ${publicaColors.lightGray}` }}
          >
            <ModelTopBar
              title={routeName(pathname)}
              session={session}
              user={user}
              publisher={session.publisher}
              classes={classes}
              delegateElevate={true}
              currentPath={pathname}
              disableTitlePaddingLeft
            />
          </Panel>
          <Panel scroll>
            <Panels maxWidth vertical relative minWidthMain largePadding>
              <Panel>
                {isExistingReport(this.state) ? (
                  <H1>
                    <span>Reports: </span>
                    <span className={classes.reportNameContainer}>
                      <TextField
                        name='Name'
                        fullWidth
                        value={isExistingReport(this.state) ? Name : 'New'}
                        onChange={this.handleChange}
                        error={!!errors.Name}
                        helperText={errors.Name}
                      />
                    </span>
                  </H1>
                ) : (
                  <H1>Reports: New</H1>
                )}
              </Panel>
              <Panel paper largeHorizontalPadding verticalPadding marginBottom={spacing.large}>
                {/* ---------- TITLE, SUPER-USER VIEWABLE CHECKBOX AND BUTTONS ---------- */}

                {/* title + only visible for super-admin button + save, close, preview & download buttons  */}
                <Grid
                  container
                  direction='row'
                  justify='space-between'
                  alignItems='center'
                  style={{ marginBottom: '25px' }}
                >
                  {/* title + only visible for super-admin button */}
                  <Grid item>
                    <Grid container direction='row' justify='flex-start' alignItems='center'>
                      {/* title */}
                      <Grid item style={{ width: '100px' }}>
                        <H2>
                          <b>Query</b>
                        </H2>
                      </Grid>
                      {/* only visible for super-admin button */}
                      <Grid item>
                        {hasRoleSuperUser(this.props.user.user) && (
                          <div className={classes.section}>
                            <FormControlLabel
                              style={{ fontSize: '12px' }}
                              label='only viewable for super user?'
                              control={
                                <Checkbox
                                  checked={SuperOnly === SuperOnlyActive}
                                  value={SuperOnly === SuperOnlyActive}
                                  name='SuperOnly'
                                  onChange={this.handleChange}
                                  color='primary'
                                />
                              }
                            />
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* save, close, preview & download buttons */}
                  <Grid item>{this.renderMainButtons()}</Grid>
                </Grid>

                {/* ---------- GENERAL PARAMETERS ---------- */}

                {/* grid for all general parameters (report type to timezone) */}
                <Grid container direction='column' justify='flex-start' alignItems='flex-start'>
                  {/* report type selection */}
                  <Grid item style={{ height: '75px' }}>
                    <Grid container direction='row' justify='flex-start' alignItems='flex-start'>
                      {/* title */}
                      <Grid
                        item
                        style={{
                          width: '150px',
                          marginBottom: '10px',
                          fontSize: '18px',
                          fontWeight: 500,
                        }}
                      >
                        Report Type
                      </Grid>
                      {/* dropdown */}
                      <Grid item style={{ width: '250px', marginTop: '5px', marginBottom: '15px' }}>
                        <MaterialSearchDropdownMulti
                          selectLimit={1}
                          enableMultiSelect={false}
                          getValueFromSearchElement={(src: IListItem) => src.title}
                          fontSize='16px'
                          fontColor='black'
                          menuTitle='Report Type'
                          list={Object.keys(reportTypesList)
                            .filter((key) => {
                              if (
                                reportTypesList[key].ID ===
                                  REPORTTYPE_HEADERBIDDER_BYAUCTIONS_FILLRATE &&
                                !this.props.session.publisher.Name.includes('Samsung')
                              ) {
                                return false;
                              }
                              return true;
                            })
                            .reduce(
                              (res, key) => Object.assign(res, { [key]: reportTypesList[key] }),
                              {},
                            )}
                          onChange={this.handleReportTypeChange}
                          handleMenuAcceptClick={() => null}
                          overrideDefaultSortMode={SortByMode.AtoZ}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* date range selection */}
                  {!reportsPublicaSettingsReport.includes(ReportType) && (
                    <>
                      <Grid item style={{ height: '75px', marginBottom: '30px' }}>
                        <Grid
                          container
                          direction='row'
                          justify='flex-start'
                          alignItems='flex-start'
                        >
                          {/* title */}
                          <Grid
                            item
                            style={{
                              width: '150px',
                              marginBottom: '10px',
                              fontSize: '18px',
                              fontWeight: 500,
                            }}
                          >
                            Date Range
                          </Grid>
                          {/* date range selector */}
                          <Grid item style={{ marginTop: '5px', marginBottom: '15px' }}>
                            <DateTimeRangeComponent
                              disabled={isPresetAggregateSelected || ReportType === REPORTTYPE_TTD}
                              timezone={Timezone}
                              start={
                                ReportType === REPORTTYPE_TTD
                                  ? getStartDate(
                                      this.props.report.Timezone || 'UTC',
                                      30,
                                      'day',
                                    ).startOf('day')
                                  : dateStart
                              }
                              end={dateEnd}
                              onChange={this.handleDateChange}
                              disableTime={true}
                              enableSelectAll={true}
                              maxDateExtended={-1}
                              minDate={moment().subtract(2, 'years')}
                            />
                          </Grid>
                          <Grid
                            item
                            style={{ minWidth: '40px', marginTop: '5px', marginBottom: '15px' }}
                          >
                            <Tooltip
                              title='Any changes made to these dates will apply to the Preview and Download options for this current report, but will reset to the last 7 days when the report is exited and reopened. Please contact your AM for reports older than two years.'
                              placement='bottom-start'
                            >
                              <InfoIcon
                                style={{
                                  verticalAlign: 'bottom',
                                  width: '1rem',
                                  color: '#929599',
                                  paddingTop: '3px',
                                }}
                              />
                            </Tooltip>
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* timezone selection */}
                      <Grid item style={{ height: '75px' }}>
                        <Grid
                          container
                          direction='row'
                          justify='flex-start'
                          alignItems='flex-start'
                        >
                          {/* title */}
                          <Grid
                            item
                            style={{
                              width: '150px',
                              marginBottom: '10px',
                              fontSize: '18px',
                              fontWeight: 500,
                            }}
                          >
                            Timezone
                          </Grid>
                          {/* timezone selector */}
                          <Grid
                            item
                            style={{ width: '400px', marginTop: '5px', marginBottom: '15px' }}
                          >
                            <MaterialSearchDropdownMulti
                              fontSize='16px'
                              menuTitle='Timezone'
                              list={timezonesList}
                              enableMultiSelect={false}
                              onChange={(list: IMenuList) => {
                                this.setState({
                                  timezonesList: list,
                                });
                              }}
                              handleMenuAcceptClick={this.handleTimezoneAcceptClick}
                              disabled={
                                isIASReport(this.state.ReportType) || ReportType === REPORTTYPE_TTD
                              }
                              overrideDefaultSortMode={SortByMode.AtoZ}
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      {/* currency selection */}
                      {!isIASReport(ReportType) &&
                        ![REPORTTYPE_CREATIVE_VALIDATION, REPORTTYPE_CREATIVE_REVIEW].includes(
                          ReportType,
                        ) && (
                          <Grid item style={{ height: '75px' }}>
                            <Grid
                              container
                              direction='row'
                              justify='flex-start'
                              alignItems='flex-start'
                            >
                              {/* title */}
                              <Grid
                                item
                                style={{
                                  width: '150px',
                                  marginBottom: '10px',
                                  fontSize: '18px',
                                  fontWeight: 500,
                                }}
                              >
                                Currency
                              </Grid>
                              {/* Currency selector */}
                              <Grid
                                item
                                style={{ width: '400px', marginTop: '5px', marginBottom: '15px' }}
                              >
                                <MaterialSearchDropdownMulti
                                  enableMultiSelect={false}
                                  getValueFromSearchElement={(src: IListItem) => src.ID}
                                  fontSize='16px'
                                  fontColor='black'
                                  // selectAll={false}
                                  menuTitle='Currency Type'
                                  list={currencyList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      currencyList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleCurrencyAcceptClick}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                    </>
                  )}
                </Grid>

                {/* ---------- FILTERS ---------- */}
                {/* filter section title */}
                {!reportsWithoutFilters.includes(ReportType) && (
                  <>
                    {ReportType !== REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS_SUPER && (
                      <div style={{ marginTop: '0px', marginBottom: '25px', fontSize: '22px' }}>
                        <b>Filters</b>
                        {hasRoleSuperUser(this.props.user.user) && (
                          <Typography>{`Graph ID *: ${this.getReportGraphID()}`}</Typography>
                        )}
                      </div>
                    )}

                    {/* select IASAnID (Super User Only) */}
                    {ReportType === REPORTTYPE_IAS_FIRST_PARTY &&
                      hasRoleSuperUser(this.props.user.user) && (
                        <Grid item style={{ width: '850px', height: '68px' }}>
                          <TextField
                            label='AnID Override *'
                            name='IASAnID'
                            style={{ width: '400px' }}
                            onChange={this.handleChangeNumber}
                            value={IASAnID}
                            InputLabelProps={{
                              style: { color: '#000000' },
                            }}
                          />
                        </Grid>
                      )}

                    {!reportsWithoutFilters.includes(ReportType) && (
                      <Grid
                        container
                        direction='column'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={2}
                      >
                        {/* filter by channels */}
                        {reportsWithChannelFilter.includes(ReportType) && (
                          <Grid item style={{ width: '850px', height: '68px' }}>
                            {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                            <div style={{ height: '25px' }}>&nbsp;</div>
                            <Grid container justify={'flex-start'} alignItems={'center'}>
                              <Grid item xs={1} style={{ paddingTop: 4 }}>
                                <IconButton
                                  onClick={() =>
                                    this.setState({
                                      IsSiteIDsIncluded:
                                        this.state.IsSiteIDsIncluded !== EBool.EBool_TRUE
                                          ? EBool.EBool_TRUE
                                          : EBool.EBool_FALSE,
                                    })
                                  }
                                >
                                  {this.state.IsSiteIDsIncluded !== EBool.EBool_FALSE ? (
                                    <CheckIcon style={{ color: 'green' }} />
                                  ) : (
                                    <BlockIcon style={{ color: 'red' }} />
                                  )}
                                </IconButton>
                              </Grid>
                              <Grid item xs={6}>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Channels'
                                  list={channelList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      channelList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleChannelAcceptClick}
                                  maxHeight={325}
                                  quickFilterOptions={quickFilterOptions}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                  loading={loadingChannels}
                                  isSelectionExcluded={
                                    this.state.IsSiteIDsIncluded !== EBool.EBool_TRUE
                                  }
                                  showPrefixID
                                />
                              </Grid>
                              <Grid item xs={5} style={{ paddingTop: 4 }}>
                                <Switch
                                  name='ChannelActiveOnly'
                                  checked={ReportFilterConfig.ChannelActiveOnly}
                                  onChange={this.handleReportFilterConfigInputChange}
                                  color='secondary'
                                />
                                Hide Archived Channels
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* filter by channels groups */}
                        {reportsWithChannelGroupFilter.includes(ReportType) && (
                          <Grid item style={{ width: '850px', height: '68px' }}>
                            {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                            <div style={{ height: '25px' }}>&nbsp;</div>
                            <Grid container justify={'flex-start'} alignItems={'center'}>
                              <Grid item xs={1} style={{ paddingTop: 4 }} />
                              <Grid item xs={6}>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Channel Groups'
                                  list={channelGroupsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      channelGroupsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleChannelGroupsAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                  loading={loadingChannelGroupsAndLabels}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* filter by bidders */}
                        {(reportsWithBidderIDFilter.includes(ReportType) ||
                          allowDealReportBidderFilters) && (
                          <Grid item style={{ width: '850px', height: '68px' }}>
                            {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                            <div style={{ height: '4px' }}>&nbsp;</div>
                            <Grid container justify={'flex-start'} alignItems={'center'}>
                              <Grid item xs={1} style={{ paddingTop: 4 }}>
                                <IconButton
                                  onClick={() =>
                                    this.setState({
                                      IsBidderIDsIncluded:
                                        this.state.IsBidderIDsIncluded !== EBool.EBool_TRUE
                                          ? EBool.EBool_TRUE
                                          : EBool.EBool_FALSE,
                                    })
                                  }
                                >
                                  {this.state.IsBidderIDsIncluded !== EBool.EBool_FALSE ? (
                                    <CheckIcon style={{ color: 'green' }} />
                                  ) : (
                                    <BlockIcon style={{ color: 'red' }} />
                                  )}
                                </IconButton>
                              </Grid>
                              <Grid item xs={6}>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Bidders'
                                  list={bidderList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      bidderList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleBidderAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                  loading={loadingBidders}
                                  isSelectionExcluded={
                                    this.state.IsBidderIDsIncluded !== EBool.EBool_TRUE
                                  }
                                  showPrefixID
                                />
                              </Grid>
                              <Grid item xs={5} style={{ paddingTop: 4 }}>
                                <Switch
                                  name='BidderActiveOnly'
                                  checked={ReportFilterConfig.BidderActiveOnly}
                                  onChange={this.handleReportFilterConfigInputChange}
                                  color='secondary'
                                />
                                Hide Archived Bidders
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        {/* filter by bidder groups */}
                        {(reportsWithBidderGroupFilter.includes(ReportType) ||
                          allowDealReportBidderFilters) && (
                          <Grid item style={{ width: '850px', height: '68px' }}>
                            {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                            <div style={{ height: '4px' }}>&nbsp;</div>
                            <Grid container justify={'flex-start'} alignItems={'center'}>
                              <Grid item xs={1} style={{ paddingTop: 4 }} />
                              <Grid item xs={6}>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Bidder Groups'
                                  list={bidderGroupsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      bidderGroupsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleBidderGroupsAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                  loading={loadingBidderGroupsAndLabels}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        )}

                        <Grid container justify='flex-start' style={{ width: '850px' }}>
                          <Grid item xs={1} style={{ width: 20 }}>
                            &nbsp;
                          </Grid>
                          <Grid item xs={11} style={{ paddingLeft: 8 }}>
                            {/* filter by inventory routes */}
                            {reportsWithInventoryRouteFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Inventory Routes'
                                  list={inventoryRouteList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      inventoryRouteList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleInventoryRoutesAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}

                            {/* filter by destinations */}
                            {reportsWithDestinationFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Destinations'
                                  list={destinationList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      destinationList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleDestinationsAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}

                            {/* filter by country */}
                            {reportsWithCountryFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Countries'
                                  list={countriesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      countriesList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleCountryAcceptClick}
                                  maxHeight={325}
                                />
                              </Grid>
                            )}

                            {/* filter by country group (region) */}
                            {reportsWithCountryGroupFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Regions'
                                  list={countryGroupsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      countryGroupsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleCountryGroupAcceptClick}
                                  maxHeight={325}
                                />
                              </Grid>
                            )}

                            {/* filter by channel label */}
                            {reportsWithChannelLabelFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Channel Labels'
                                  list={channelLabelsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      channelLabelsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleChannelLabelAcceptClick}
                                  maxHeight={325}
                                  loading={loadingChannelGroupsAndLabels}
                                />
                              </Grid>
                            )}

                            {/* filter by bidder label */}
                            {ReportType === REPORTTYPE_HEADERBIDDER_BYBUYERS && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Bidder Labels'
                                  list={bidderLabelsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      bidderLabelsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleBidderLabelAcceptClick}
                                  maxHeight={325}
                                  loading={loadingBidderGroupsAndLabels}
                                />
                              </Grid>
                            )}

                            {/* filter by DMAs*/}
                            {ReportType === REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT && (
                              <Grid item style={{ width: '850px' }}>
                                <MaterialLabelDropdownMulti
                                  loading={false}
                                  menuTitle={'Filter by DMA (can be comma separated)'}
                                  list={[]}
                                  selected={DMAs.length === 0 ? [] : DMAs.split(',')}
                                  width={'400px'}
                                  inputLabelProps={{
                                    style: { color: '#000000' },
                                  }}
                                  onChange={(values) => {
                                    const DMAsInput: string[] = [];
                                    values.forEach((value) => {
                                      DMAsInput.push(value.Name);
                                    });
                                    this.setState({
                                      DMAs: DMAsInput.join(','),
                                    });
                                  }}
                                />
                              </Grid>
                            )}

                            {/* filter by states */}
                            {reportsWithStateFilter.includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                {/* top margin - for some reason this field don't align at the end of the grid item box ... */}
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                {/* filter by state component */}
                                <MaterialSearchDropdownMulti
                                  getValueFromSearchElement={(src: IListItem) => src.title}
                                  fontSize='16px'
                                  fontColor='black'
                                  selectAll={false}
                                  titlePrefix='Filter by'
                                  menuTitle='States'
                                  width='400px'
                                  disabled={this.state.Countries.length !== 1}
                                  list={statesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      statesList: list,
                                    });
                                    if (
                                      [REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT].includes(
                                        ReportType,
                                      )
                                    ) {
                                      this.setState({
                                        States: Object.values(list)
                                          .filter((i: IListItem) => i.selected)
                                          .map((i: IListItem) => `'${i.ID}'`),
                                      });
                                    }
                                  }}
                                  handleMenuAcceptClick={this.handleStatesAcceptClick}
                                  showModalButton={true}
                                  modalButton={
                                    <Tooltip
                                      title='Filter By States only works if a single country is selected'
                                      placement='bottom-start'
                                    >
                                      <InfoIcon
                                        style={{
                                          verticalAlign: 'bottom',
                                          width: '1rem',
                                          color: '#929599',
                                          paddingTop: '3px',
                                        }}
                                      />
                                    </Tooltip>
                                  }
                                />
                              </Grid>
                            )}

                            {/* filter by device type */}
                            {reportsWithDeviceTypeFilter.includes(ReportType) &&
                              deviceTypes.length > 0 && (
                                <Grid item style={{ width: '464px' }}>
                                  <CategoryMultiSelect
                                    label='Filter by Device Type'
                                    name='DeviceTypes'
                                    filterHelperText='Search for Device Types'
                                    items={deviceTypes}
                                    onChange={this.handleChangeSelect}
                                    values={DeviceTypes}
                                    helperText={errors.DeviceTypes}
                                    search
                                    maxSearchResultsCount={5}
                                  />
                                </Grid>
                              )}

                            {/* filter by device subtype */}
                            {reportsWithDeviceSubtypeFilter.includes(ReportType) &&
                              deviceSubtypes.length > 0 && (
                                <Grid item style={{ width: '464px' }}>
                                  <CategoryMultiSelect
                                    label='Filter by Device Subtype'
                                    name='DeviceSubtypes'
                                    filterHelperText='Search for Device Subtypes'
                                    items={deviceSubtypes}
                                    onChange={this.handleChangeSelect}
                                    values={DeviceSubtypes}
                                    helperText={errors.DeviceSubtypes}
                                    search
                                    maxSearchResultsCount={5}
                                  />
                                </Grid>
                              )}

                            {/* filter by device environment */}
                            {reportsWithDeviceEnvironmentFilter.includes(ReportType) && (
                              <Grid item style={{ width: '464px' }}>
                                <CategoryMultiSelect
                                  label='Filter by Device Environment'
                                  name='DeviceEnvs'
                                  filterHelperText='Search for Device Environments'
                                  items={deviceEnvs.slice(1)}
                                  onChange={this.handleChangeSelect}
                                  values={DeviceEnvs}
                                  helperText={errors.DeviceEnvs}
                                  search
                                  maxSearchResultsCount={5}
                                />
                              </Grid>
                            )}

                            {/* filter by adomains - this is a freeform filter so users can type in any string they want */}
                            {[
                              REPORTTYPE_HEADERBIDDER_BYBUYERS,
                              REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
                            ].includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <TextField
                                  label='Filter by Adomain (can be comma separated)'
                                  name='Adomains'
                                  style={{ width: '400px' }}
                                  onChange={this.handleChangeAdomain}
                                  value={Adomains}
                                  InputLabelProps={{
                                    style: { color: '#000000' },
                                  }}
                                  error={!!errors.Adomains}
                                  helperText={errors.Adomains}
                                />
                              </Grid>
                            )}
                            {/* filter by dealids - this is a freeform filter so users can type in any string they want */}
                            {[REPORTTYPE_HEADERBIDDER_BYBUYERS].includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <TextField
                                  label='Filter by Deal IDs (can be comma separated) or "none"'
                                  name='DealIDs'
                                  style={{ width: '400px' }}
                                  onChange={this.handleChange}
                                  value={DealIDs}
                                  InputLabelProps={{
                                    style: { color: '#000000' },
                                  }}
                                />
                              </Grid>
                            )}

                            {/* filter by demand source */}
                            {(reportsWithDemandSourceFilter.includes(ReportType) ||
                              allowDealReportBidderFilters) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={ReportType !== REPORTTYPE_TTD}
                                  titlePrefix='Filter by'
                                  menuTitle='Demand Source'
                                  list={bidderCodesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      bidderCodesList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleBidderCodeAcceptClick}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by orders */}
                            {ReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Orders'
                                  list={ordersList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      ordersList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleOrderAcceptClick}
                                  maxHeight={325}
                                  loading={loadingOrders}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by line items */}
                            {ReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Line Items'
                                  list={campaignsList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      campaignsList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleCampaignAcceptClick}
                                  maxHeight={325}
                                  loading={loadingCampaigns}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by order aliases */}
                            {ReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Order Aliases'
                                  list={orderAliasesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      orderAliasesList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleOrderAliasAcceptClick}
                                  maxHeight={325}
                                  loading={loadingOrderAliases}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by line item aliases */}
                            {ReportType === REPORTTYPE_HEADERBIDDER_CAMPAIGN && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Line Item Aliases'
                                  list={lineItemAliasesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      lineItemAliasesList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={this.handleLineItemAliasAcceptClick}
                                  maxHeight={325}
                                  loading={loadingLineItemAliases}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by networks */}
                            {(ReportType === REPORTTYPE_STREAM ||
                              ReportType === REPORTTYPE_STREAM_USER_ACTIVITY) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Networks'
                                  list={networksList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      networksList: list,
                                    });
                                  }}
                                  maxHeight={325}
                                  handleMenuAcceptClick={this.handleNetworkAcceptClick}
                                  loading={loadingNetworks}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by segments */}
                            {(ReportType === REPORTTYPE_HEADERBIDDER_AUDIENCE_SEGMENTS ||
                              ReportType === REPORTTYPE_HEADERBIDDER_UNIQUE_USER_REPORT) && (
                              <Grid item style={{ width: '464px' }}>
                                <CategoryMultiSelect
                                  label='Filter by Audience Segment List'
                                  name='SegmentIDs'
                                  items={segments.map((segment: IAudienceSegment) => {
                                    return {
                                      key: segment.ID,
                                      text: `[${segment.ID}] ${segment.Name}`,
                                    } as Partial<IMultiSelectOption> as IMultiSelectOption;
                                  })}
                                  onChange={this.handleChangeSelect}
                                  values={SegmentIDs}
                                  helperText={errors.SegmentIDs}
                                />
                              </Grid>
                            )}
                            {/* filter by streamTypes */}
                            {(ReportType === REPORTTYPE_STREAM ||
                              ReportType === REPORTTYPE_STREAM_USER_ACTIVITY) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='StreamTypes'
                                  list={streamTypesList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      streamTypesList: list,
                                      StreamTypes: Object.values(list)
                                        .filter((i: IListItem) => i.selected)
                                        .map((i: IListItem) => i.ID),
                                    });
                                  }}
                                  handleMenuAcceptClick={() => null}
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Grid>
                            )}
                            {/* filter by IsPartialAdBreak */}
                            {ReportType === REPORTTYPE_STREAM && (
                              <Rows>
                                <MaterialSearchDropdownMulti
                                  width='400px'
                                  fontSize='16px'
                                  selectAll={true}
                                  titlePrefix='Filter by'
                                  menuTitle='Is Partial Ad Break'
                                  list={this.state.IsPartialAdBreakList}
                                  onChange={(list: IMenuList) => {
                                    this.setState({
                                      IsPartialAdBreakList: list,
                                    });
                                  }}
                                  handleMenuAcceptClick={
                                    this.handleReportFilterConfigTrueFalseClick
                                  }
                                  maxHeight={325}
                                  overrideDefaultSortMode={SortByMode.AtoZ}
                                />
                              </Rows>
                            )}
                            {/* filter by livestream */}
                            {[
                              REPORTTYPE_HEADERBIDDER_BYBUYERS,
                              REPORTTYPE_HEADERBIDDER_BYAUCTIONS,
                            ].includes(ReportType) && (
                              <Grid item style={{ width: '850px', height: '68px' }}>
                                <div style={{ height: '25px' }}>&nbsp;</div>
                                <Select
                                  label='Livestream'
                                  name='Livestream'
                                  defaultValue='none'
                                  value={
                                    ReportFilterConfig.Livestream === undefined
                                      ? 'none'
                                      : ReportFilterConfig.Livestream
                                  }
                                  onChange={this.handleReportFilterConfigInputChange}
                                  style={{ fontSize: 16, width: '400px' }}
                                >
                                  {
                                    <MenuItem value='none' disabled>
                                      Filter by Livestream
                                    </MenuItem>
                                  }
                                  {livestreamSelectOptions.map((item: ILiveStreamSelectOption) => (
                                    <MenuItem key={item.value || -1} value={item.value}>
                                      {item.text} {item.value !== undefined && `[${item.value}]`}
                                    </MenuItem>
                                  ))}
                                </Select>
                                {
                                  <Button
                                    style={{ color: getColorTheme('secondaryButtonText') }}
                                    classes={{ root: classes.button }}
                                    onClick={this.clearButtonOnClick}
                                  >
                                    Clear
                                  </Button>
                                }
                              </Grid>
                            )}
                            {/* filter by ias device types */}
                            {reportsWithIASDeviceTypeFilter.includes(ReportType) && (
                              <Grid item style={{ width: '464px' }}>
                                <CategoryMultiSelect
                                  label='Filter by Device Type'
                                  name='IASDeviceTypes'
                                  filterHelperText='Search for Device Types'
                                  items={
                                    ReportType === REPORTTYPE_IAS_FIRST_PARTY
                                      ? iasFirstPartyDeviceTypes
                                      : iasThirdPartyDeviceTypes
                                  }
                                  onChange={this.handleChangeSelect}
                                  values={DeviceTypes}
                                  helperText={errors.DeviceTypes}
                                  search
                                  maxSearchResultsCount={5}
                                />
                              </Grid>
                            )}
                            {/* filter by bidder tier */}
                            {reportsWithBidderTierFilter.includes(ReportType) &&
                              this.getReportGraphID() === '41' && (
                                <Grid item style={{ width: '850px', height: '68px' }}>
                                  <div style={{ height: '25px' }}>&nbsp;</div>
                                  <MaterialSearchDropdownMulti
                                    width='400px'
                                    fontSize='16px'
                                    selectAll={false}
                                    titlePrefix='Filter by'
                                    menuTitle='Bidder Tiers'
                                    list={this.state.bidderTierFilterList}
                                    onChange={(list: IMenuList) => {
                                      this.setState({
                                        bidderTierFilterList: list,
                                        BidderTierFilter: Object.values(list)
                                          .filter((i: IListItem) => i.selected)
                                          .map((i: IListItem) => i.ID)
                                          .join(','),
                                      });
                                    }}
                                    handleMenuAcceptClick={this.handleBidderTierAcceptClick}
                                    maxHeight={325}
                                  />
                                </Grid>
                              )}
                            {/* filter by venue id - only for creative validation */}
                            {ReportType === REPORTTYPE_CREATIVE_VALIDATION &&
                              this.props.session.publisher.ID === '408' && (
                                <Grid item style={{ width: '850px', height: '68px' }}>
                                  <TextField
                                    label='Filter by Venue IDs (at least one Venue ID required, can be comma separated)'
                                    name='VenueIDs'
                                    style={{ width: '622px' }}
                                    onChange={this.handleChange}
                                    value={VenueIDs}
                                    InputLabelProps={{
                                      style: { color: '#000000' },
                                    }}
                                    error={!!errors.VenueIDs}
                                    helperText={errors.VenueIDs}
                                  />
                                </Grid>
                              )}
                            {/* filter by advertiser id */}
                            {reportsWithAdvertiserIDFilter.includes(ReportType) &&
                              publisherIDsWithAdvertiserRulesFilter.includes(
                                this.props.session.publisher.ID,
                              ) && (
                                <Grid item style={{ width: '850px', height: '68px' }}>
                                  <TextField
                                    label='Filter by Advertiser IDs (can be comma separated)'
                                    name='AdvertiserIDs'
                                    style={{ width: '400px' }}
                                    onChange={this.handleChangeReportFilterConfig}
                                    value={ReportFilterConfig.AdvertiserIDs}
                                    InputLabelProps={{
                                      style: { color: '#000000' },
                                    }}
                                    error={!!errors.AdvertiserIDs}
                                    helperText={errors.AdvertiserIDs}
                                  />
                                </Grid>
                              )}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  </>
                )}
                {/* grid for all the filter section */}

                {/* ---------- METRICS ---------- */}
                {/* metric title */}
                {!reportsWithoutMetrics.includes(ReportType) &&
                  !reportsPublicaSettingsReport.includes(ReportType) && (
                    <>
                      <div style={{ marginTop: '51px', marginBottom: '25px', fontSize: '22px' }}>
                        <b>Metrics</b>
                      </div>

                      {/* metrics dropdown */}
                      <Grid
                        container
                        direction='column'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={2}
                      >
                        <Grid item style={{ width: '850px' }}>
                          <CategoryMultiSelect
                            label='Metrics'
                            name='Metrics'
                            subCategories={this.getSubCategories()}
                            items={this.getMetricsList()}
                            graphID={this.getReportGraphID()}
                            onChange={(name: string, value: string[]) => {
                              this.specialMetricsUpdates(value);
                              this.handleChangeSelectWithSorting(
                                name,
                                value,
                                getMetricColumnsByReportID(
                                  ReportType,
                                  this.props.session.publisher.ID,
                                  fwPublisherIDs,
                                  GroupByOptions || [],
                                  this.props.user.user,
                                  isCreativeTagEventsEnabled(this.props.session.publisher),
                                ),
                              );
                              this.updateSelectedGroupBys(value);
                            }}
                            search={true}
                            filterHelperText='Search for Metrics'
                            values={Metrics}
                            helperText={errors.Metrics}
                            error={!!errors.Metrics}
                            campaignFields={['campaign_request', 'campaign_inventory_request']}
                            disableCampaignFields={
                              GroupByOptions.includes('creative_id') ||
                              GroupByOptions.includes('creative_name')
                            }
                            dealFields={['endpoint_requests', 'endpoint_responses']}
                            disableDealFields={
                              ReportType === REPORTTYPE_HEADERBIDDER_DEALS &&
                              (GroupByOptions.includes('biddername') ||
                                GroupByOptions.includes('bidder_type') ||
                                GroupByOptions.includes('bid_error_code') ||
                                GroupByOptions.includes('bid_won_reject_reason'))
                            }
                            woyFields={woyWhitelistedMetricParams}
                            disableNonWOYFields={GroupByOptions.includes('week_of_year')}
                            disableWOY={
                              !GroupByOptions.includes('week_of_year') &&
                              this.checkWOYDisable(Metrics)
                            }
                            publisherID={session.publisher.ID}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                {/* ---------- GROUPS BY ---------- */}

                {/* groups by grid */}
                {availableGroupBys.length > 0 &&
                  !reportsPublicaSettingsReport.includes(ReportType) &&
                  !reportsWithoutGroupBy.includes(ReportType) && (
                    <>
                      {/* group by title */}
                      <div style={{ marginTop: '51px', marginBottom: '25px', fontSize: '22px' }}>
                        <b>Group by</b>
                      </div>

                      <Grid
                        container
                        direction='column'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={2}
                        style={{ marginBottom: '15px' }}
                      >
                        {/* group by dropdown */}
                        <Grid item style={{ width: '850px' }}>
                          <CategoryMultiSelect
                            label='Group By'
                            name='GroupByOptions'
                            subCategories={[
                              { title: 'Preset Aggregates', matchRegex: /Yesterday|Last .+ Days/ },
                              {
                                title: 'Inventory Routes',
                                matchRegex:
                                  /Destination ID|Destination Error Code|Destination Site ID|Destination Type|Inventory Route ID|Inventory Route Condition|Inventory Route Error Code|Inventory Route Name|Destination Name|Destination Site Name/,
                              },
                              { title: 'Time Range', matchRegex: /Day|Hour|Month|Week Of Year/ },
                              {
                                title: 'Supply',
                                matchRegex:
                                  /Ad Break Position|App Bundle ID|App Name|Network Channel Site ID|Channel Group|Channel ID|Channel Name|Channel Label|Livestream|Livestream (Stream Type)|Slot #|Publisher Name|Site Name|Inbound Deal ID|Inbound WSeat|Freewheel Section ID|Pod Duration|Network ID|Network Name|Slot Number|Site Page/,
                              },
                              {
                                title: 'Demand',
                                matchRegex:
                                  /Adomain|Ad Source ID|Bidder Group|.*Bidder ID$|Bidder Name|Bidder Label|Bidder Parameter|Deal ID|Demand Source|Deal Name|Demand Path|DSP|IAB Category|Spotx Endpoint|Spotx Channel ID|Bidder Tier|Bidder Subtier|Bidder Tier Participating|Filled Ads Per Pod|Delivered Ads Per Pod|Bidder Testing|Ad Duration|Bid Density|Bid Saver|Shared Inventory|Share of Voice/,
                              },
                              {
                                title: 'Privacy',
                                matchRegex: /US Privacy|GDPR|GDPR Consent|Do Not Track|COPPA/,
                              },
                              {
                                title: 'Device',
                                matchRegex:
                                  /Device Type|Device Subtype|Device Environment|IP Type|Operating System|Device ID Type|APK Build|Device Make|Device Model|Device OS|Device Geo Region/,
                              },
                              { title: 'Geo', matchRegex: /Region|City|Country|DMA|State|Zip/ },
                              { title: 'Content', matchRegex: /^Content/ },
                              {
                                title: 'Line Item / Order',
                                matchRegex:
                                  /Line Item Name|Order ID|Order Name|Line Item Status|Line Item ID|Agency Name|Advertiser Name|Salesperson Name|Trafficker Name|Creative Name|Line Item Needs Creative|Line Item Start Date|Creative ID|Flight Date Checkpoint Name|Flight Date Checkpoint ID|Order Alias|Line Item Alias/,
                              },
                              { title: 'Custom', matchRegex: /^Custom.*/ },
                              { title: 'Other Dimensions', matchRegex: /./ },
                            ]}
                            items={availableGroupBys}
                            graphID={this.getReportGraphID()}
                            onChange={(name: string, value: string[]) => {
                              this.handleChangeSelectWithSorting(
                                name,
                                value,
                                getGroupColumnsByReportID(
                                  ReportType,
                                  this.props.session.publisher.ID,
                                ),
                              );
                              this.handlePresetAggregateSelection(value);
                            }}
                            search={true}
                            values={GroupByOptions}
                            filterHelperText='Search for Group By Options'
                            helperText={errors.GroupByOptions}
                            error={!!errors.GroupByOptions}
                            campaignFields={['creative_id', 'creative_name']}
                            disableCampaignFields={
                              Metrics.includes('campaign_request') ||
                              Metrics.includes('campaign_inventory_request')
                            }
                            dealFields={[
                              'bidder_type',
                              'biddername',
                              'bid_won_reject_reason',
                              'bid_error_code',
                            ]}
                            disableDealFields={
                              ReportType === REPORTTYPE_HEADERBIDDER_DEALS &&
                              (Metrics.includes('endpoint_requests') ||
                                Metrics.includes('endpoint_responses'))
                            }
                            woyFields={woyWhitelistedGroupByParams}
                            disableNonWOYFields={GroupByOptions.includes('week_of_year')}
                            disableWOY={
                              !GroupByOptions.includes('week_of_year') &&
                              this.checkWOYDisable(GroupByOptions)
                            }
                            disableItems={
                              Metrics.length === 1 && Metrics.includes('sessions_per_user')
                                ? []
                                : ['num_of_users']
                            }
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}

                {/* --------- ORDER BY --------- */}
                {!reportsWithoutOrderBy.includes(ReportType) &&
                  !isIASReport(ReportType) &&
                  ReportType !== REPORTTYPE_TTD && (
                    <>
                      <Grid
                        style={{
                          marginTop: 51,
                          marginBottom: 25,
                          fontSize: 22,
                        }}
                      >
                        <b>Order By</b>
                      </Grid>

                      <Grid
                        container
                        direction='column'
                        justify='flex-start'
                        alignItems='flex-start'
                        spacing={2}
                        style={{ marginBottom: 15 }}
                      >
                        <Grid item style={{ width: 700 }}>
                          <SelectOrderByView
                            reportOrderBy={ReportOrderBy}
                            handleChangeOrderBy={this.handleChangeOrderBy}
                            items={this.getMetricsList().filter((sqlOption) =>
                              Metrics.includes(sqlOption.key),
                            )}
                          />
                        </Grid>
                      </Grid>
                    </>
                  )}
                {/* ---------- LIMIT ---------- */}

                {!reportsWithoutMetrics.includes(ReportType) && (
                  <>
                    <Grid
                      style={{
                        marginTop: 25,
                        marginBottom: 25,
                        fontSize: 22,
                      }}
                    >
                      <b>Limit</b>
                    </Grid>

                    <Grid
                      container
                      direction='column'
                      justify='flex-start'
                      alignItems='flex-start'
                      spacing={2}
                      style={{ marginBottom: 15 }}
                    >
                      <Grid item style={{ width: 700 }}>
                        <TextField
                          label='Limit'
                          name='ReportLimit'
                          value={ReportLimit}
                          style={{ width: 622 }}
                          onChange={this.handleChange}
                          error={!!errors.ReportLimit}
                          helperText={errors.ReportLimit}
                          InputLabelProps={{
                            style: { color: '#000000' },
                          }}
                        />
                      </Grid>
                    </Grid>
                  </>
                )}
              </Panel>

              <Panel paper largeHorizontalPadding verticalPadding>
                <RowButton
                  left={<H2>Schedule</H2>}
                  right={
                    <Switch checked={Active === ReportActive} onChange={this.handleChangeActive} />
                  }
                />
                {Active === ReportActive && (
                  <div>
                    {!isExistingReport(this.state) && (
                      <div className={classes.section}>
                        <TextField
                          label='Report Name'
                          name='Name'
                          fullWidth
                          value={Name}
                          onChange={this.handleChange}
                          error={!!errors.Name}
                          helperText={errors.Name}
                          InputLabelProps={{
                            style: { color: '#000000' },
                          }}
                        />
                      </div>
                    )}
                    <div className={classes.section}>
                      <TextField
                        label='Subject Name'
                        name='Subject'
                        fullWidth
                        value={Subject}
                        onChange={this.handleChange}
                        error={!!errors.Subject}
                        helperText={errors.Subject}
                        InputLabelProps={{
                          style: { color: '#000000' },
                        }}
                      />
                    </div>
                    <div className={classes.section}>
                      <TextField
                        select
                        fullWidth
                        label='Frequency'
                        name='Frequency'
                        value={Frequency}
                        onChange={this.handleChange}
                        margin='normal'
                        error={!!errors.Frequency}
                        helperText={errors.Frequency}
                        InputLabelProps={{
                          style: { color: '#000000' },
                        }}
                      >
                        {frequency.map(({ key, text }: ISelectModel) => {
                          return (
                            <MenuItem key={key} value={key}>
                              {text}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </div>
                    {(Frequency === FrequencyWeekly || Frequency === FrequencyMonthly) && (
                      <div className={classes.section}>
                        <TextField
                          select
                          fullWidth
                          label='Scheduled Day'
                          name='ScheduledDay'
                          value={ScheduledDay}
                          onChange={this.handleChange}
                          margin='normal'
                          error={!!errors.ScheduledDay}
                          helperText={errors.ScheduledDay}
                          InputLabelProps={{
                            style: { color: '#000000' },
                          }}
                        >
                          {(Frequency === FrequencyWeekly
                            ? scheduledDayWeekly
                            : scheduledDayMonthly
                          ).map(({ key, text }: ISelectModel) => {
                            return (
                              <MenuItem key={key} value={key}>
                                {text}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      </div>
                    )}
                    <div className={classes.section}>
                      <TextField
                        select
                        fullWidth
                        label='Period'
                        name='Period'
                        value={Period}
                        onChange={this.handleChange}
                        margin='normal'
                        error={!!errors.Period}
                        helperText={errors.Period}
                        InputLabelProps={{
                          style: { color: '#000000' },
                        }}
                      >
                        {ReportType === REPORTTYPE_TTD
                          ? [
                              <MenuItem key={'8'} value={'8'} selected={true}>
                                Last 31 Days
                              </MenuItem>,
                            ]
                          : period.map(({ key, text }: ISelectModel) => {
                              return (
                                <MenuItem key={key} value={key}>
                                  {text}
                                </MenuItem>
                              );
                            })}
                      </TextField>
                    </div>
                    <div className={classes.section}>
                      <FormRecipientView
                        onChange={this.handleChangeRecipients}
                        value={Recipients}
                      />
                    </div>
                    {hasRoleSuperUser(this.props.user.user) && (
                      <div className={classes.section}>
                        <RowButton
                          left={
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            >
                              <Typography>Send to S3 Access Point</Typography>
                              <Switch
                                checked={ShouldUploadToExternalS3 === EBool.EBool_TRUE}
                                onChange={this.handleChangeShouldUploadToExternalS3}
                              />
                            </div>
                          }
                        />
                      </div>
                    )}
                    <Cols
                      style={{
                        alignItems: 'flex-start',
                        columnGap: '8px',
                      }}
                    >
                      <Col>
                        {!writeAuthorization.isAuthorized ? (
                          <Grid item style={{ marginLeft: '16px' }}>
                            <ChipInactive label='Read-Only' />
                          </Grid>
                        ) : (
                          <ButtonView
                            disabled={!writeAuthorization.isAuthorized}
                            onClick={() => this.saveReport(true)}
                            text={
                              isExistingReport(this.state)
                                ? 'Save Scheduled Report'
                                : 'Create Schedule'
                            }
                            active={updating}
                          />
                        )}
                      </Col>
                      <Col>
                        <Tooltip title={this.getToolTipMsg(false, true)} placement='bottom'>
                          <div>
                            <ButtonView
                              disabled={
                                !writeAuthorization.isAuthorized ||
                                !this.state.Metrics.length ||
                                !this.state.GroupByOptions.length ||
                                !this.isPeriodAllowed()
                              }
                              onClick={() =>
                                IsExtendedGraph(this.getReportGraphID())
                                  ? this.warnBeforeSendEmail()
                                  : this.sendEmail(false, false)
                              }
                              text='Send Now'
                              active={sending}
                            />
                          </div>
                        </Tooltip>
                      </Col>
                      {hasRoleSuperUser(this.props.user.user) && (
                        <Col>
                          <Tooltip
                            title='For now this only works on a saved report and only uses the settings that are saved. Please save the report before using.'
                            placement='bottom-start'
                          >
                            <div>
                              <ButtonView
                                disabled={!writeAuthorization.isAuthorized || !this.state.ID}
                                onClick={this.scheduleReport}
                                text='Send Scheduled Report Now *'
                                active={sending}
                              />
                            </div>
                          </Tooltip>
                        </Col>
                      )}
                    </Cols>
                  </div>
                )}
              </Panel>
              <PanelBreak height={spacing.large} />
              <Dialog
                className='pb-bidder-report-form-view_extended-table-warning'
                open={isSendNowWarningOpen}
                onClose={() => this.onCloseSendEmailWarning(false)}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
              >
                <DialogTitle>Send Report Now</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <Grid container justify={'flex-start'} alignItems={'center'}>
                      <Grid item xs={1}>
                        <InfoIcon fontSize={'large'} />
                      </Grid>
                      <Grid item xs={11}>
                        <p>
                          Based on the report settings, your report may take a long time to process.
                          Click Continue below to proceed.
                        </p>
                      </Grid>
                    </Grid>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => this.onCloseSendEmailWarning(false)} autoFocus>
                    Cancel
                  </Button>
                  <Button onClick={() => this.onCloseSendEmailWarning(true)} color='primary'>
                    Continue
                  </Button>
                </DialogActions>
              </Dialog>

              <SnackbarView
                open={!!snackbarMessage}
                error={!!snackbarError}
                onClose={this.snackbarClose}
              >
                {snackbarMessage}
              </SnackbarView>
            </Panels>
          </Panel>
        </Panels>
      );
    }
  },
);
